/**
 * @license
 * @qwik.dev/core 2.0.0-beta.37-dev+5c6a303
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ce, isBrowser as Oe } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as Ne } from "@qwik.dev/core/preloader";

const je = !1;

const Fe = (t, ...n) => De(!1, t, ...n);

const De = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const Xe = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const i = t[e << 1];
        if (i === n) {
            return e << 1;
        }
        i < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const We = (t, n, e, s, o = !1) => {
    const i = Xe(t, n, s);
    i >= 0 ? e != null || o ? t[i + 1] = e : t.splice(i, 2) : (e != null || o) && t.splice(i ^ -1, 0, n, e);
};

const Ve = (t, n, e) => {
    const s = Xe(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ue = (t, n, e) => Xe(t, n, e) >= 0;

const ze = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Be = t => typeof t === "object" && t !== null;

const Qe = t => Array.isArray(t);

const He = t => typeof t === "string";

const Je = t => typeof t === "function";

const Ye = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = De(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Ge = "<sync>";

const Ke = t => typeof t === "function" && typeof t.getSymbol === "function";

const nd = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Ze = "q:type";

const ti = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const ii = 124;

const si = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const ri = "q:renderFn";

const oi = "q:targetEl";

const li = "⚡️";

const ui = "q:slot";

const ci = "q:s";

const fi = "[q\\:patch]";

const ai = "q:r";

const ed = "q:rp";

const hi = "q:style";

const di = "style[q\\:style]";

const pi = di + ",style[q\\:sstyle]";

const $i = "q:sstyle";

const yi = "q:ctx";

const mi = "q:brefs";

const wi = (t, n) => t["qFuncs_" + n] || [];

const vi = "q:base";

const bi = "q:container-island";

const _i = "/" + bi;

const gi = "q:ignore";

const Ei = "/" + gi;

const Si = "q:container";

const ki = "/" + Si;

const Ri = "q:cursorBoundary";

const Pi = "q:template";

const Ti = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const qi = "http://www.w3.org/1999/xhtml";

const Ai = "http://www.w3.org/2000/svg";

const Mi = "http://www.w3.org/1998/Math/MathML";

const xi = "qRender";

const Ii = "q:id";

const Ni = "q:key";

const Ci = "q:props";

const Oi = "q:seq";

const ji = "q:seqIdx";

const Li = "q:p";

const Fi = "q:ps";

const Xi = ":on";

const Wi = ":onIdx";

const Vi = ":onFlags";

const Ui = ":nearestCursorBoundary";

const zi = ":";

const Bi = "dangerouslySetInnerHTML";

const Hi = 100;

const Ji = t => !!t && typeof t == "object" && typeof t.then === "function";

const Yi = (t, n, e) => {
    try {
        const s = t();
        return Ji(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const Gi = (t, n) => Ji(t) ? t.then(n) : n(t);

const Ki = t => new Promise(n => {
    setTimeout(n, t);
});

const Zi = t => {
    throw t;
};

function n(t, n = Zi) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!Ji(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Hi;
    const i = async e => {
        for (;Ji(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!Ji(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(i) : i(s);
}

const ts = t => li + t;

const ns = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + ts(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const es = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + is(t.slice(s, -1));
        }
    }
    return null;
}

const is = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = ss(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const ss = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const rs = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const os = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const ls = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const us = t => {
    if (!t) {
        return "";
    }
    if (He(t)) {
        return t.trim();
    }
    const n = [];
    if (Qe(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = us(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const cs = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const fs = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Qe(t)) {
            throw Ye(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(cs(e) + ":" + as(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function i(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = us(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = fs(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function i(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const as = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => os.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const hs = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.un = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const ds = () => ({
    isServer: Ce,
    importSymbol(t, n, e) {
        if (Ce) {
            const t = nd(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Ye(6, [ e ]);
        }
        if (!n) {
            throw Ye(14, [ e ]);
        }
        if (!t) {
            throw Ye(13, [ n, e ]);
        }
        const s = ps(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const i = o.href;
        return import(i).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const ps = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(vi) ?? s, s);
    return new URL(e, o);
};

let $s = /*#__PURE__ */ ds();

const ys = t => $s = t;

const ms = () => $s;

const sd = () => $s.isServer;

const od = typeof document !== "undefined";

const ws = !Ce && od;

const vs = ws ? document : void 0;

const bs = ws && vs.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const _s = /\.[mc]?js$/;

const gs = t => {
    let n = Es.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            cn: t,
            Ut: _s.test(t) ? 0 : 3,
            fn: n,
            an: 1,
            hn: performance.now(),
            dn: 0,
            pn: 0
        }))(t, e);
        Es.set(t, n);
    }
    return n;
};

const Es = new Map;

let Ss = 0;

const ks = [];

const Rs = hs(function id() {
    Ts = !1;
    if (!ks.length) {
        return;
    }
    const t = performance.now() + 10;
    let n = !1;
    for (;ks.length; ) {
        const e = ks[0];
        const s = e.an;
        const o = 1 - s;
        if (!(o >= .99 || Ss < 25)) {
            break;
        }
        ks.shift();
        Is(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && ks.length && !Ts) {
        Ts = !0;
        Rs();
    }
});

const Ps = hs(s);

let Ts = !1;

let qs = !1;

let As = !1;

const Ms = [];

const xs = () => {
    const t = Ms[Ms.length - 1];
    const n = t.$n;
    if (t.fn) {
        const e = t.Nt;
        if (e >= t.fn.length) {
            Ms.pop();
            return !1;
        }
        const s = t.fn[e];
        t.Nt = e + 1;
        const o = gs(s.cn);
        if (o.an === 0) {
            return !0;
        }
        const i = 1 - n.an;
        let r;
        if (i === 1 || i >= .99) {
            r = Math.min(.01, 1 - s.yn);
        } else {
            const t = 1 - s.yn * i;
            const n = s.mn;
            const e = t / n;
            r = Math.max(.02, o.an * e);
            s.mn = e;
        }
        Ms.push({
            $n: o,
            an: r,
            wn: t.wn
        });
        return !0;
    }
    if (t.wn?.has(n)) {
        Ms.pop();
        return !1;
    }
    const e = n.an;
    n.an = t.an;
    if (e - n.an < .01) {
        Ms.pop();
        return !1;
    }
    if (n.fn?.length) {
        const e = t.wn || new Set;
        e.add(n);
        t.wn = e;
        t.fn = n.fn;
        t.Nt = 0;
        return !1;
    }
    Ms.pop();
    return !1;
};

function s() {
    if (As || !Ms.length) {
        return;
    }
    qs = !1;
    As = !0;
    const t = ws ? performance.now() + 10 : 0;
    let n = !1;
    for (;Ms.length; ) {
        n = !0;
        const e = xs();
        if (ws && e && performance.now() >= t) {
            if (!qs) {
                qs = !0;
                Ps();
            }
            break;
        }
    }
    As = !1;
    n && ws && Rs();
}

const Is = t => {
    if (t.Ut >= 2) {
        return;
    }
    Ss++;
    const n = performance.now();
    t.dn = n - t.hn;
    t.Ut = 2;
    const e = vs.createElement("link");
    e.href = new URL("undefined" + t.cn, vs.baseURI).toString();
    e.rel = bs;
    e.as = "script";
    e.onload = e.onerror = () => {
        Ss--;
        const s = performance.now();
        t.pn = s - n;
        t.Ut = 4;
        e.remove();
        Rs();
    };
    vs.head.appendChild(e);
};

const Ns = (t, n) => {
    const e = gs(t);
    e && ((t, n) => {
        Ms.unshift({
            $n: t,
            an: n,
            wn: void 0
        });
    })(e, n);
};

ws && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Ns(e, 0);
                }
            } else {
                Ns(t, 0);
            }
            ws ? Ps() : s();
        })(t);
    }
});

const Cs = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const Os = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const js = '"';

const Ls = "[";

const Fs = "]";

const Ds = ",";

const Xs = "2.0.0-beta.37-dev+5c6a303";

const Ws = t => t.nodeType === 1;

const rd = t => t.Hn;

const Vs = Symbol();

class Us {
    [Vs]=void 0;
}

const zs = t => t === "foreignObject";

const Bs = t => t === "svg" || zs(t);

const Qs = t => t === "math";

function r(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== zi && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n];
            const c = i.nodeType;
            c === 3 ? o.appendChild(i.cloneNode()) : c === 1 && o.appendChild(r(i, i.localName, e, s));
        }
    }
    return o;
}

const Hs = {
    elementNamespace: qi,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!Ql(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && zs(Ql(t));
    let o = qi;
    let i = 0;
    const r = typeof n === "string" || $l(n);
    if (r && function c(t) {
        if (typeof t === "string") {
            return Bs(t);
        }
        if ($l(t)) {
            return Bs(Ql(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Ai;
        i = 512;
    } else if (r && function l(t) {
        if (typeof t === "string") {
            return Qs(t);
        }
        if ($l(t)) {
            return Qs(Ql(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Mi;
        i = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Ai : e ? Mi : qi;
        i = t.flags & 1536;
    }
    Hs.elementNamespace = o;
    Hs.elementNamespaceFlag = i;
    return Hs;
}

class Js {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Vs]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Ys extends Js {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, i, r, c) {
        super(n, e, s, o, i);
        this.key = t;
        this.firstChild = r;
        this.lastChild = c;
    }
}

class Gs extends Ys {
    node;
    elementName;
    constructor(t, n, e, s, o, i, r, c, l, u) {
        super(t, n, e, s, o, i, r, c);
        this.node = l;
        this.elementName = u;
    }
}

class Ks extends Js {
    node;
    text;
    constructor(t, n, e, s, o, i, r) {
        super(t, n, e, s, o);
        this.node = i;
        this.text = r;
    }
}

const Zs = [];

const tr = [];

function l(t, n) {
    const e = y(n).priority;
    let s = Zs.length;
    for (let t = 0; t < Zs.length; t++) {
        const n = y(Zs[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Zs.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Zs.length; t++) {
        const n = Zs[t];
        let e = !1;
        for (let t = 0; t < tr.length; t++) {
            const s = tr[t];
            if ($u(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    tr.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = Zs.indexOf(t);
    if (s !== -1) {
        Zs.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = tr.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = tr.length - 1;
    e !== s && (tr[e] = tr[s]);
    tr.pop();
    n.o--;
    return !0;
}

const nr = new WeakMap;

const er = ":nodeProps";

const ir = ":nodeDiff";

const sr = ":errorData";

const rr = ":signal";

const or = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && dn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return nr.get(t) ?? null;
}

const lr = Symbol();

const ur = Symbol();

const cr = Symbol();

const fr = Symbol();

const ar = Symbol();

const hr = Symbol();

const dr = [];

const pr = {};

Object.freeze(dr);

Object.freeze(pr);

function m(t) {
    return new Proxy({}, new $r(t));
}

class $r {
    owner;
    ft=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === lr) {
            return this.owner.constProps;
        }
        if (n === ur) {
            return this.owner.varProps;
        }
        if (n === cr) {
            return this.owner;
        }
        if (n === fr) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = wr(this.owner, n);
            n in this.owner.varProps && yr(this, n);
        }
        return s instanceof Jr ? s.value : s;
    }
    set(t, n, s) {
        if (n === cr) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === lr) {
            this.owner.constProps = s;
        } else if (n === ur) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === pr ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                mr(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && mr(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === lr || n === ur) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && yr(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const yr = (t, n) => {
    const e = Af();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.sn;
    s && In(t.owner._proxy, n, t, s);
};

const mr = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ft, n);
    e && Nu(t.$, t, e);
    return !!e;
};

const wr = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const vr = (t, n) => br(t)?.[n] || _r(t)?.[n] || null;

const br = t => {
    if (!t) {
        return null;
    }
    return ur in t ? "children" in t ? {
        ...t[ur],
        children: t.children
    } : t[ur] : t;
};

const _r = t => {
    if (!t) {
        return null;
    }
    return lr in t ? t[lr] : null;
};

const gr = t => t && ur in t;

const Er = Symbol();

class Sr {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const kr = Symbol();

const Rr = Symbol();

const Pr = Symbol();

function w(t, n, e) {
    t[Vs] || (Ce && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(mi, new Map) : t[Vs] = new Map);
    const o = t[Vs];
    let i = o.get(n);
    if (!i) {
        i = new Sr(t, n);
        o.set(n, i);
    }
    e && (i.data = e);
    return i;
}

const Tr = (t, n) => (e, s) => {
    const o = xe();
    o.sn = w(t, ":");
    o.$ = n || void 0;
    return qe(o, () => {
        if (Je(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (qu(e)) {
            return e.value;
        }
        if (Be(e) && zu(e)) {
            In(Xu(e), Pr, Du(e), o.sn);
            return e;
        }
        throw Ye(2);
    });
};

class qr {
    Ct;
    ft=void 0;
    $=null;
    vn=null;
    constructor(t, n) {
        this.$ = t || Af()?.$ || null;
        this.Ct = n;
    }
    trigger() {
        Nu(this.$, this, this.ft);
    }
    force() {
        Nu(this.$, this, this.ft);
    }
    get untrackedValue() {
        return this.Ct;
    }
    set untrackedValue(t) {
        this.Ct = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = Af();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.sn;
        if (e) {
            const t = Ce;
            const s = this.ft ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            Au(s, e);
            Mu(e, this);
            if (t) {
                const t = Iu(n.$, this.$);
                o && t?.bn?.(this, e, null);
                xu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Ct) {
            this.Ct = t;
            Nu(this.$, this, this.ft);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Ct
        };
    }
}

class Ar {
    _n;
    gn=null;
    En=!1;
    Sn=!0;
    constructor(t, n, e) {
        this._n = t;
        if (n !== void 0) {
            this.info = n;
            this.kn = e;
        }
    }
    get track() {
        return this.Rn ||= Tr(this._n, this._n.$);
    }
    get abortSignal() {
        return (this.Pn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this._n.Ct;
        if (t !== Er) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.Tn ||= []).push(t);
    }
}

class Mr extends qr {
    Ot;
    h;
    [Vs]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || Af()?.$, Er);
        this.Ot = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Ct = typeof o === "function" ? o() : o);
        const i = s.concurrency;
        if (i !== void 0 && i >= 0 && i !== 1) {
            this.Ft = i;
            this.Dt = [];
        }
        s.timeout && (this.Xt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
        s.allowStale === !1 && (this.h |= 128);
        const r = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        r && (this.expires = r);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    invalidate(t) {
        if (arguments.length > 0) {
            this.qn = t;
            this.kn = this.kn === void 0 ? 1 : this.kn + 1;
        }
        if (this.h & 512) {
            this.An(!0, this.h & 128);
            return;
        }
        this.h |= 1;
        const e = xe();
        e.$ = this.$ || void 0;
        const s = n(Ae.bind(this, e, this.p));
        Ji(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.qn = void 0;
            if (this.Dt) {
                for (let t = 0; t < this.Dt.length; t++) {
                    this.Dt[t].Sn = !1;
                }
            } else {
                this.ot && (this.ot.Sn = !1);
            }
            this.Mn();
            super.value = t;
            this.xn();
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.ot?.gn) {
            if (this.Ct === Er || Ce) {
                throw this.ot?.gn;
            }
            return this.Ct;
        }
        if (this.jt) {
            throw this.jt;
        }
        if (Ce && this.h & 64 && this.Ct === Er) {
            throw Ye(35);
        }
        return this.Ct;
    }
    set untrackedValue(t) {
        this.Ct = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = Af();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.sn;
            if (t) {
                Au(this.yt ||= new Set, t);
                Mu(t, this);
                xu(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Lt) {
            this.Lt = t;
            Nu(this.$, this, this.yt);
        }
    }
    get untrackedPending() {
        this.p();
        if (Ce && this.ot?.gn) {
            throw this.ot?.gn;
        }
        return !!this.Lt;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = Af();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.sn;
            if (t) {
                Au(this.wt ||= new Set, t);
                Mu(t, this);
                xu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.jt) {
            this.jt = t;
            Nu(this.$, this, this.wt);
        }
    }
    get untrackedError() {
        this.p();
        if (Ce && this.ot?.gn) {
            throw this.ot?.gn;
        }
        return this.jt;
    }
    get expires() {
        return this.Tt || 0;
    }
    set expires(t) {
        this.Mn();
        this.Tt = t;
        this.Tt && this.In() && this.xn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Tt && this.In()) {
            this.Mn();
            this.xn();
        }
    }
    get interval() {
        const t = this.Tt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    An(t, n) {
        this.h |= 1;
        this.Mn();
        n && (this.Ct = Er);
        t && (this.ft?.size || this.yt?.size || this.wt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.ot && this.Nn(this.ot, t);
    }
    vt() {
        if (!(this.h & 32) || this.In()) {
            return;
        }
        if (!Oe) {
            return;
        }
        setTimeout(() => {
            this.In() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.ot?.gn; ) {
            await (this.ot?.gn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.Cn();
        }
        const t = this.Ot;
        Tu(t);
        const e = this.ot;
        if (e && !e.En) {
            e.En = !0;
            e.Pn?.abort();
            this.On(e);
        }
        const s = new Ar(this, this.qn, this.kn);
        this.ot = s;
        let o;
        try {
            o = this.jn(t.resolved, s);
        } catch (t) {
            if (Ji(t)) {
                throw t;
            }
            s.kn === this.kn && (this.qn = void 0);
            this.h &= -2;
            this.Ln(s, t);
            return;
        }
        if (Ji(o)) {
            this.h |= 512;
            this.h &= -2;
            let t = o;
            const e = () => {
                const n = t ?? this.jn(this.Ot.resolved, s);
                t = void 0;
                return n;
            };
            s.gn = this.Fn(s, () => n(e));
            return;
        }
        s.kn === this.kn && (this.qn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    jn(t, n) {
        const e = t;
        if (this.h & 1024) {
            let t = Af();
            t?.sn && (t = {
                ...t,
                sn: void 0
            });
            return Ae(t, e, [ n ]);
        }
        const s = this.$ ||= Af()?.$ || null;
        const o = w(this, ".");
        s && Rn(s, o);
        const i = xe();
        i.$ = s || void 0;
        i.sn = o;
        return Ae(i, e, [ n ]);
    }
    Cn() {
        if (Ce && this.h & 64) {
            this.Lt = !0;
            this.$?.serializationCtx.qt.add(this);
            return;
        }
        this.Mn();
        this.h &= -2;
        const t = this.ot;
        t && this.Nn(t);
        const n = this.Ft === 0 ? Infinity : this.Ft ?? 1;
        if (this.Dt ? this.Dt.length >= n : t?.gn) {
            this.h |= 1;
            return;
        }
        const e = this.kn;
        const s = new Ar(this, this.qn, e);
        this.ot = s;
        this.Dt && this.Dt.push(s);
        s.gn = this.Dn(s);
    }
    async Dn(t) {
        let e = this.Ot.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Ot.resolve();
            if (t.Pn?.signal.aborted) {
                t.gn = null;
                return;
            }
        }
        this.Xt && (this.Xn = setTimeout(() => {
            const n = Error(`timeout ${this.Xt}ms`);
            this.Ln(t, n);
            t.Pn?.abort(n);
        }, this.Xt));
        return this.Fn(t, () => n(() => this.jn(e, t)));
    }
    async Fn(t, n) {
        try {
            const e = n();
            let s;
            if (Ji(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.gn = null;
            if (t.Sn) {
                const n = this.Dt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].Sn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.gn = null;
            this.Ln(t, n);
        }
        if ((() => t === this.ot)()) {
            clearTimeout(this.Xn);
            t.kn === this.kn && (this.qn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedPending = !1;
                this.xn();
            }
        }
    }
    Ln(t, n) {
        if (t !== this.ot || !t.Sn) {
            return;
        }
        t.Sn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Er;
    }
    async un() {
        this.Mn();
        clearTimeout(this.Xn);
        const t = this.ot;
        t && this.Nn(t);
        this.Dt ? await Promise.all(this.Dt.map(t => t.gn)) : await (t?.gn);
    }
    Mn() {
        if (this.Wn !== void 0) {
            clearTimeout(this.Wn);
            this.Wn = void 0;
        }
    }
    xn() {
        if (Ce || !this.Tt) {
            return;
        }
        this.Mn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.Wn = setTimeout(() => this.An(t, n), this.Tt);
        this.Wn?.unref?.();
    }
    In() {
        return !!(this.ft?.size || this.yt?.size || this.wt?.size);
    }
    Nn(t, n) {
        if (t.En) {
            return;
        }
        t.En = !0;
        t.Pn?.abort(n);
        t.gn = Gi(t.gn, () => this.Vn(t));
    }
    On(t) {
        const n = t.Tn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    Ji(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Vn(t) {
        const n = () => {
            t.gn = null;
            const n = this.Dt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.On(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const xr = t => (n, ...e) => t.call(null, aa(n), ...e);

class Ir extends Mr {
    constructor(t, n) {
        super(t, n, 17);
    }
    Un=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Tu(this.Ot);
        const t = Nf(this.Ot.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Ct === Er ? e : this.Ct;
        const i = Of(() => this.Un ? s?.(o) || o : n(o), this, ".", this.$);
        this.Un = !0;
        this.h &= -2;
        const r = this.Un && i !== "undefined" || i !== this.Ct;
        if (r) {
            this.Ct = i;
            Nu(this.$, this, this.ft);
        }
    }
}

class Nr extends Mr {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const Cr = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Or = (t, n) => new Mr(n?.container || null, t, Ou(n?.serializationStrategy || "always"), n);

const jr = (t, n) => new Nr(n?.container || null, t, Ou(n?.serializationStrategy || "always"), n);

const Lr = t => new Ir(null, t);

const Fr = t => new qr(null, t);

const Dr = /*#__PURE__*/ xr(Or);

const Xr = /*#__PURE__*/ xr(jr);

const Wr = xr(Lr);

const Vr = t => t.value;

const Ur = (t, n) => t[n];

const zr = t => {
    if (t.length === 1) {
        if (qu(t[0])) {
            return t[0].vn ||= new Jr(null, Vr, t, null);
        }
        if (zu(t[0])) {
            return new Jr(null, Vr, t, null);
        }
        return t[0].value;
    }
    return new Jr(null, Ur, t, null);
};

const Br = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Be(n)) {
        return n[e];
    }
    if (qu(n)) {
        if (n instanceof Jr) {
            return n;
        }
        return zr(t);
    }
    if (gr(n)) {
        const s = n[lr];
        const o = n[ur];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Qr(n, t);
        }
    } else {
        const s = Xu(n);
        if (s) {
            const n = s[e];
            return Qr(n, t);
        }
    }
    return n[e];
};

const Qr = (t, n) => qu(t) ? t : zr(n);

const Hr = (t, n) => {
    const e = Br(t, n);
    if (e === ar) {
        return t[n];
    }
    return e;
};

class Jr extends qr {
    ut;
    lt;
    Rt;
    h;
    m=void 0;
    [Vs]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, Er);
        this.ut = e;
        this.lt = n;
        this.Rt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, rr, this);
                yn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Nu(this.$, this, this.ft);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Ct;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Of(() => this.lt(...this.ut), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Ct;
        if (n) {
            this.h |= 2;
            this.Ct = t;
        }
    }
    st() {
        return this.lt === Vr && qu(this.ut[0]) ? this.ut[0] : this;
    }
    set value(t) {
        throw Ye(31);
    }
    get value() {
        return super.value;
    }
}

class Yr {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class Gr {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, i, r, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!r;
        this.key = i === null || i === void 0 ? null : typeof i === "string" ? i : "" + i;
        this.varProps = !n || Cs(n) ? pr : n;
        this.constProps = !e || Cs(e) ? null : e;
    }
    get props() {
        return this._proxy ||= m(this);
    }
}

const Kr = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Zr = t => t instanceof Gr;

const to = (t, n, e) => {
    if (typeof t === "string") {
        const s = Ee(n);
        return Rf(s, () => {
            Kf(Zf(s, t));
            return e();
        });
    }
    return e();
};

function v(t, n) {
    return to(this, n, () => {
        const t = Gf[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function b(t, n) {
    return to(this, n, () => {
        const t = Gf[0];
        t.value = n.checked;
    });
}

function _(t, n) {
    return to(this, n, () => {
        if (Gf) {
            for (let t = 0; t < Gf.length; t++) {
                const n = Gf[t];
                n instanceof Nr && n.h & 64 && n.p();
            }
        }
    });
}

const no = "bind:value";

const eo = "bind:checked";

const io = "passive:";

const so = "preventdefault:";

const ro = Object.prototype.hasOwnProperty;

const oo = (t, n, e, s, o = !1) => {
    let i = t;
    let r = o;
    if (n.length > 0) {
        if (!r) {
            i = {
                ...i
            };
            r = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete i[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(is(n.slice(15)))) {
                if (!r) {
                    i = {
                        ...i
                    };
                    r = !0;
                }
                delete i[n];
            }
        }
    }
    return i;
};

const lo = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return is(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return is(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return is(t.slice(11, -1));
    }
    return null;
};

const uo = (t, n, s, o, i = !1) => {
    let r = t;
    let c = i;
    for (let t = 0; t < n.length; t++) {
        const i = n[t];
        const l = lo(i);
        const u = e(i, o.has(l));
        if (u) {
            if (!c) {
                r = {
                    ...r
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(i)) && (r[u] = r[i]);
            delete r[i];
        }
    }
    return r;
};

const co = (t, n, e, s, o, i, r) => new Gr(t, n, e, s, o, i, !1, r);

const fo = (t, n, e, s, o, i, r) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const i = [];
        const r = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(io)) {
                    i.push(o);
                    t.add(is(o.slice(8)));
                } else {
                    o.startsWith(so) ? h.push(o) : lo(o) !== null ? s.push(o) : o === eo ? a = e[o] : o === no && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(io)) {
                    r.push(s);
                    t.add(is(s.slice(8)));
                } else {
                    s.startsWith(so) ? d.push(s) : lo(s) !== null ? o.push(s) : s === eo ? a = n[s] : s === no && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = oo(e, i, h, t, l);
            l = l || e !== n;
            e = uo(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = oo(n, r, d, t, u);
            u = u || n !== e;
            n = uo(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && ro.call(n, eo) && delete n[eo];
                if (e && ro.call(e, eo)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[eo];
                }
                n.checked = a;
                const t = ia(null, "_chk", b, null, [ a ]);
                if (e && ro.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Kr(n, "q-e:input", t) || c;
                }
                c = Kr(n, "q-e:input", t) || c;
            } else if (f) {
                n && ro.call(n, no) && delete n[no];
                if (e && ro.call(e, no)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[no];
                }
                n.value = f;
                const t = ia(null, "_val", v, null, [ f ]);
                if (e && ro.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Kr(n, "q-e:input", t) || c;
                }
                c = Kr(n, "q-e:input", t) || c;
            }
        }
        if (n && ro.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && ro.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                i ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Gr(t, n, e, s, o, i, c || !0, r);
};

const ao = (t, n, e, s) => yo(t, n, s);

const ho = (t, n, e, s, o) => yo(t, {
    ...e,
    ...n
}, o);

const po = (t, n, e, s, o, i) => yo(t, {
    ...e,
    ...n,
    children: s
}, i);

const $o = t => t.children;

const yo = (t, n, e, s, o) => fo(t, n, null, null, 0, e, o);

const mo = yo;

const wo = yo;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return fo(t, n, null, s.children, 0, o);
}

const vo = t => t.children;

const bo = (t, n) => new Gr($o, null, null, t.children, 0, n);

const _o = t => co($o, null, {
    [ci]: ""
}, t.children, 0, t.name ?? "");

const go = Symbol();

const Eo = () => null;

const So = () => null;

const ko = t => t.children;

const Ro = (t, n) => yo(bo, {
    children: yo(Po, t)
}, n);

const Po = () => null;

let To = null;

let qo = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    qo || (qo = t.setAttributeNS);
                    qo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            To || (To = t.setAttribute);
            To.call(t, n, e);
        })(t, n, e);
    }
}

const Ao = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Mo = (t, n = [], e = {}) => {
    let s = null;
    const o = t[lr];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const i = e;
    const r = t[ur];
    for (const t in r) {
        n.includes(t) || (i[t] = r[t]);
    }
    return m(new Gr(null, i, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && Ao.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Jr) {
            return jf(n, t, ":", e);
        }
    }
    return wr(n, "name") || "";
}

class xo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Io {
    target;
    constructor(t) {
        this.target = t;
    }
}

class No {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Co {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Oo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const jo = t => new xo(t);

const Lo = t => new Io(t);

const Fo = (t, n) => new No(t, n);

const Do = (t, n, e) => new Co(t, n, e);

const Xo = (t, n, e, s = null, o = !1) => new Oo(t, n, e, s, o);

const Wo = () => {
    const t = xf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Oi);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Oi, s);
    }
    let o = t.$.getHostProp(e, ji);
    o === null && (o = 0);
    t.$.setHostProp(e, ji, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Vo = t => {
    const n = Je(t) && !ma(t) ? qe(void 0, t) : t;
    return Fr(n);
};

const Uo = t => zo(Vo, t);

const zo = (t, ...n) => {
    const {val: e, set: s} = Wo();
    if (e != null) {
        return e;
    }
    t = Je(t) && !ma(t) ? Nf(t, ...n) : t;
    return s(t);
};

const Bo = () => ({
    pending: Fr(0),
    version: Fr(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = q(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, Ri);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    gl(t, Ui, null);
}

function q(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return _l(t, Ui, null) || null;
    }(n) || P(t, n);
}

function A(t, n) {
    __EXPERIMENTAL__.suspense && gl(t, Ui, n);
}

function M(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    A(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        M(t, o, P(t, o) || e);
    }
}

const Qo = t => {
    if (t.un) {
        try {
            t.un();
        } catch (t) {
            Fe(t);
        }
        t.un = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const n = Ee(s);
        return Rf(n, () => x(t, e, s, If(e, s, n)));
    }
    const i = o.$;
    const r = o.m;
    kl(i, r);
    let c = t;
    if (r.flags & 64) {
        let n;
        if (!(r.flags & 128)) {
            n = !0;
            r.flags |= 128;
        }
        const o = n ? i._ : null;
        const l = _l(r, Li, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = _l(r, Fi, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(r.flags & 32)) {
            return Ae(o, c, [ e, s ]);
        }
    }, t => i.handleError(t, r));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Ee(n);
    return Rf(e, () => {
        const s = If(t, n, e);
        typeof this === "string" && Kf(Zf(s.$, this));
        const o = Gf[0];
        return x(o, t, n, s);
    });
}

function N(t) {
    return t.k === t.R ? t.T : null;
}

function C(t) {
    return t.q || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const Ho = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, i) {
    gl(n, e, i);
    mn(t, Xo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        O: s,
        j: [],
        L: [],
        D: [],
        k: null,
        q: null,
        X: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new Yr({
                O: s,
                et: !0
            }),
            it: new Yr({
                O: s,
                et: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const i = t ?? L(n, e, s, o);
    (function r(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.it.data.O = o;
        t.L.length = 0;
        t.D.length = 0;
    })(i, n, e, s, o);
    return i;
}

const Jo = (t, n, e, s, o, i, r) => D(F(r, t, n, o, i), e, s);

const Yo = (t, n, e, s, o, i, r, c, l = !1, u) => D(F(u, t, n, r, c), e, s, o, i, l);

function D(t, n, e, s = Yl(e), o = null, i = !1) {
    X(t, n, e, s, o, i);
    const r = G(t);
    if (Ji(r)) {
        return r.finally(() => {
            K(t);
        });
    }
    K(t);
}

function X(t, n, e, s = Yl(e), o = null, i = !1) {
    const r = t.Z;
    t.Z = i || r;
    t.k = e;
    t.X = null;
    t.q = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    mt(t, t.J);
                } else if (typeof t.J === "number") {
                    mt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (Zr(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.J, n);
                            const e = t.J.constProps && Ho.call(t.J.constProps, Bi) || Ho.call(t.J.varProps, Bi);
                            e ? t.X || Z(t, !1) : U(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === vo) {
                                nt(t);
                                dt(t, "F", t.J.key);
                                U(t, t.J.children, !0);
                            } else if (n === _o) {
                                nt(t);
                                J(t) || U(t, t.J.children, !0);
                            } else if (n === bt) {
                                H(t);
                                U(t, t.J.children, !0, !0);
                            } else if (n === So) {
                                tt(t);
                            } else if (n === Eo) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        U(t, t.J, !1);
                    } else if (qu(t.J)) {
                        dt(t, "S", null);
                        const n = t.J instanceof Jr ? t.J.st() : t.J;
                        const e = t.q?.[Vs]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Jr && (s = xt(e, n));
                        if (!s) {
                            const e = t.X || t.q;
                            U(t, W(t, () => jf(n, e, ".", t.$)), !0);
                        }
                    } else if (Ji(t.J)) {
                        dt(t, "A", null);
                        t.L.push(t.J, t.X || t.q);
                    }
                } else {
                    t.J === go || mt(t, "");
                }
                V(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.Z = r;
    }
}

function W(t, e) {
    try {
        return e();
    } catch (s) {
        if (Ji(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.X || t.q);
            return null;
        }
        throw s;
    }
}

function V(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return z(t);
    }
    t.X !== null ? t.X = null : t.q = O(t, t.q);
}

function U(t, n, e, s = !1) {
    if (!s && (n == null || e && Qe(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = !s && t.Z || !!t.X || !Yl(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.X || t.q;
        t.q = Yl(t.k);
        t.X = null;
    }
    t.K = !1;
}

function z(t) {
    const n = t.j.pop();
    if (n) {
        t.Z = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.X = t.j.pop();
        t.q = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    V(t);
}

function B(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.q, t.X, t.U, t.W, t.B, t.Z);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function Q(t) {
    if (t.X) {
        return C(t);
    }
    return O(t, t.q) || N(t);
}

function H(t) {
    const n = t.J;
    const e = n.key;
    t.q = _l(t.k, e, n => ql(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.X = dl();
        gl(t.X, ui, e);
        t.X.slotParent = t.k;
        gl(t.k, e, t.X);
    }
}

function J(t) {
    const n = t.J;
    const e = Eu(t.k);
    const s = k(e, n, t.$);
    const o = wr(n, Ri) || null;
    const i = e ? _l(e, s, null) : null;
    if (i == null) {
        t.X = dl();
        gl(t.X, ui, s);
        gl(t.X, Ri, o);
        M(t.$, t.X, o);
        e && gl(e, s, t.X);
        Wl(t.M, t.k, t.X, Q(t));
        return !1;
    }
    if (i === t.q) {} else {
        const n = i.parent;
        t.X = i;
        gl(t.X, ui, s);
        gl(t.X, Ri, o);
        M(t.$, t.X, o);
        e && gl(e, s, t.X);
        Xl(t.M, t.X);
        Wl(t.M, t.k, t.X, Q(t));
        n && $l(n) && !n.firstChild && Ql(n) === Pi && zl(t.M, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            zl(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function G(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (Ji(n)) {
            return n.then(n => {
                X(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        X(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.M = null;
    t.N = null;
}

function Z(t, n = !0) {
    const e = t.q && Yl(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        Bl(t.M, t.q, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = O(t, t.q);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                zl(t.M, t.k, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.q !== null && wl(t.q)) {
        const n = t.q;
        t.q = O(t, t.q);
        zl(t.M, t.k, n, !0);
    }
}

function et(t, n, e) {
    if (qu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Ye(15, [ e ]);
}

function it(t, e, s, o, i) {
    return n(() => jf(o, e, s, t, i));
}

function st(t, n, e, s, o) {
    const r = t.O;
    const c = s.then(t => E(n, e, i(e, t, r), o));
    t.D.push(c);
}

function rt(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Si, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, s) {
    const r = function c(t, n) {
        const e = Ul(t.k, !0);
        const s = o(e, n);
        const i = document;
        const r = s.elementNamespaceFlag === 0 ? i.createElement(n) : i.createElementNS(s.elementNamespace, n);
        t.X = fl(r, n);
        t.X.flags |= s.elementNamespaceFlag;
        return r;
    }(t, e);
    const l = t.X;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (es(n)) {
                ut(n, o, r, l, t);
                continue;
            }
            if (n === "ref" && et(o, r, s)) {
                continue;
            }
            qu(o) && (o = it(t.$, t.X, n, o, t.tt.nt));
            if (Ji(o)) {
                st(t, r, n, o, u);
                continue;
            }
            if (n === Bi) {
                rt(r, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(r, o)) {
                continue;
            }
            E(r, n, i(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.X.key = a);
    if (t.O) {
        const e = Ho.call(n.varProps, "class") || n.constProps && Ho.call(n.constProps, "class");
        e || r.setAttribute("class", t.O);
    }
    Ol(t.M, t.k, t.X, C(t));
}

function ut(t, n, e, s, o) {
    const i = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[i] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[i] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && El(o.M, s, t, "");
    (function r(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, i);
}

function ct(t, n, e) {
    if (t.Z) {
        lt(t, n, e, null);
    } else {
        const s = t.q && $l(t.q);
        const o = s && e === Ql(t.q);
        const i = n.key;
        const r = s && t.q.key;
        if (o && i === r) {
            at(t, e, i);
        } else {
            const s = ft(e, i);
            ht(t, e, i, s, t.k) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.X || t.q;
    s && function i(t, n, e, s) {
        t.Z || kl(t.$, n);
        const o = n.props;
        for (const i in e) {
            const r = e[i];
            if (o && Ho.call(o, i)) {
                const e = o[i];
                Pt(r, e) || Go(t, n, i, r, s);
            } else {
                r != null && Go(t, n, i, r, s);
            }
        }
        if (o) {
            for (const i in o) {
                Ho.call(e, i) || i.charAt(0) === ":" || es(i) || Go(t, n, i, null, s);
            }
        }
    }(t, o, s, null);
}

const Go = (t, n, e, s, o) => {
    if (es(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === Li || e === Fi) {
        gl(n, e, s);
        n.flags |= 192;
        return;
    }
    const i = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const r = n[Vs]?.get(e);
    if (qu(s)) {
        const o = s instanceof Jr ? s.st() : s;
        if (r?.backRef?.has(o)) {
            return;
        }
        r && Rn(t.$, r);
        const i = n;
        s = it(t.$, i, e, o, t.tt.it);
    } else {
        r && Rn(t.$, r);
    }
    if (Ji(s)) {
        const o = n;
        const r = s.then(n => {
            j(t.M, o, e, n, t.O, i);
        });
        t.D.push(r);
        return;
    }
    j(t.M, n, e, s, t.O, i);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, i) {
    t.X = function r(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = $l(o) ? Ql(o) : null;
                const i = wt(o) || vt(o, t.$._);
                if (i === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const i = N(t);
            let r = t.q;
            for (;r && r !== i; ) {
                const o = $l(r) ? Ql(r) : null;
                const i = wt(r) || vt(r, t.$._);
                s === null && i == e && o == n ? s = r : i === null ? t.U.push(o, r) : t.W.set(ft(o, i), r);
                r = r.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const i = t.W.get(o);
            if (i) {
                s = i;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = $l(t.q) ? Ql(t.q) : null;
                    const e = wt(t.q) || vt(t.q, t.$._);
                    if (e != null) {
                        const s = ft(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = $l(s) ? Ql(s) : null;
                const e = wt(s) || vt(s, t.$._);
                if (e != null) {
                    const o = ft(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.X) {
        s || Wl(t.M, o, t.X, C(t));
        t.q = t.X;
        t.X = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (i && t.q) {
                const n = wt(t.q) || vt(t.q, t.$._);
                if (n != null) {
                    const e = $l(t.q) ? Ql(t.q) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && Wl(t.M, o, n, C(t));
            t.q = n;
            t.X = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.q);
    const i = t.q && vl(t.q);
    const r = i && o === e && (!s || !!e);
    if (r) {
        at(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        jl(t.M, t.k, t.X = dl(), Q(t));
        t.X.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.k, !0)) {
        jl(t.M, t.k, t.X = dl(), Q(t));
        t.X.key = e;
    }
}

function pt(t, n) {
    const e = n[ya];
    let s = t.X || t.q;
    const o = t.J;
    if (e) {
        const n = o.props;
        let i = !1;
        const [r] = e;
        const c = r.rt;
        const l = vt(s, t.$._);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, r, n);
                s = t.X;
                i = !0;
            }
        } else {
            if (ht(t, null, u, u, t.k)) {
                $t(t, s, r, n);
                i = !0;
            }
            s = t.X || t.q;
        }
        if (s) {
            const e = _l(s, Ci, t.$._);
            if (!i) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[lr], e[lr], e[fr], s, !1);
                        o ||= t;
                        const i = _t(n[ur], e[ur], e[fr], s, !0);
                        o ||= i;
                        e[cr] = n[cr];
                    } else if (n) {
                        gl(t, Ci, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, r, n);
                    s = t.X;
                    i = !0;
                }
                i ||= c;
            }
            if (i) {
                gl(s, ri, r);
                s.flags &= -33;
                yn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Gr(bt, null, null, [], 0, t);
            const i = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            We(i, t, o(t), 0);
                        }
                    }
                }
            }
            if (i.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Zr(n) && wr(n, ui) || "") + "";
                const r = Xe(i, e, 0);
                let c;
                r >= 0 ? c = i[r + 1] : i.splice(~r, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = i.length - 2; t >= 0; t -= 2) {
                i.splice(t, 1);
            }
            U(t, i, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const i = wt(s);
        const r = e === i;
        const c = vt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.X;
        } else if (r) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.k) && yt(t);
            s = t.X || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!vl(e) || _l(e, ri, null) === null); ) {
                e = e.parent || Eu(e);
            }
            (function i(t, n, e, s) {
                const o = t.props ||= {};
                o[or] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            yn(t.$, s, 8, t.N);
        }
    }
}

function $t(t, n, e, s) {
    n && kn(t.$, n);
    jl(t.M, t.k, t.X = dl(), Q(t));
    const o = t.J;
    gl(t.X, ri, e);
    gl(t.X, Ci, s);
    t.X.key = o.key;
}

function yt(t) {
    jl(t.M, t.k, t.X = dl(), Q(t));
    const n = t.J;
    gl(t.X, Ci, n.props);
    n.key && (t.X.key = n.key);
}

function mt(t, n) {
    if (t.q !== null) {
        const e = _u(t.q);
        if (e === 3) {
            if (n !== Hl(t.q)) {
                Jl(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    Ol(t.M, t.k, t.X = hl(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || wl(t)) {
        return null;
    }
    return t.key;
}

function vt(t, n) {
    if (t == null || wl(t)) {
        return null;
    }
    const e = _l(t, ri, n);
    return e ? e.rt : null;
}

function bt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let i = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === mi) {
                continue;
            }
            const r = t[s];
            const c = n?.[s];
            if (!n || !Pt(r, c) && !Tt(r, c)) {
                if (s === "class") {
                    if (At(r, c)) {
                        continue;
                    }
                } else if (s === "style" && qt(r, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = r);
                    const t = mr(e, s);
                    t || (i = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === mi) {
                continue;
            }
            if ((!t || !Ho.call(t, s)) && o) {
                delete n[s];
                const t = mr(e, s);
                t || (i = !0);
            }
        }
    }
    return i;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return Cs(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    const i = s && dn(s) ? y(s) : null;
    if (wl(e)) {
        Rt(o);
        return;
    }
    let r = null;
    for (;;) {
        i && o !== s && dn(o) && a(t, i, o);
        const c = o.flags;
        if (c & 3) {
            kn(t, o);
            Rt(o);
            const i = c & 2 && _l(o, ri, null) !== null;
            if (i) {
                const e = t.getHostProp(o, Oi);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const i = e[n];
                        if (Be(i)) {
                            const n = Pu(i);
                            if (n && i.h & 1) {
                                i.h |= 16;
                                yn(t, o, 128, s);
                                continue;
                            }
                            (i instanceof Mr || i instanceof Jr) && (i.h & 4 || kn(t, i));
                            (n || i instanceof Mr && (i.h & 512 || i.ot)) && Qo(i);
                        }
                    }
                }
                const i = o.props;
                if (i) {
                    const e = Object.keys(i);
                    for (let o = 0; o < e.length; o++) {
                        const r = e[o];
                        if (S(r)) {
                            const e = i[r];
                            if (e) {
                                i[r] = null;
                                const o = typeof e === "string" ? ql(t.rootVNode, e) : e;
                                let c = Yl(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const r = bl(o);
            if (r) {
                if (o === e) {
                    const n = Yl(o);
                    if (n) {
                        bn(n);
                        return;
                    }
                    St(t, o);
                }
            } else {
                const t = Yl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        r = o.parent;
        for (;r; ) {
            if (r === e) {
                return;
            }
            const t = r.nextSibling;
            if (t) {
                o = t;
                break;
            }
            r = r.parent;
        }
        if (r == null) {
            return;
        }
    }
}

function St(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, ui);
    e != null && t.getHostProp(n.slotParent, e) === n && gl(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Ql(s) === Pi) {
            St(t, e);
            zl(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Jr && n instanceof Jr && Mt(n, t);
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    if (qu(t) && qu(n)) {
        const e = t instanceof Jr ? t.st() : t;
        const s = n instanceof Jr ? n.st() : n;
        return Nf(() => e.value === s.value);
    }
    return !1;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return fs(t) === fs(n);
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return us(t) === us(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.lt === t.lt && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ut, t.ut);
}

function xt(t, n) {
    if (!(n instanceof Jr)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Jr && Mt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Ko = (t, n, e, s, o) => {
    const i = Me(t.nn, n, t);
    if (e) {
        i.sn = w(e, ":");
        i.$ = t;
    }
    let r;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, ri));
    if (Ke(s)) {
        o = o || t.getHostProp(n, Ci) || pr;
        "children" in o && delete o.children;
        r = s.getFn(i);
    } else if (ma(s)) {
        const t = s;
        r = () => Ae(i, t, [ o || pr, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        r = () => Ae(i, t, [ o || pr ]);
    }
    const l = Ce;
    const u = (e = 0) => Yi(() => {
        if (!c) {
            t.setHostProp(n, ji, null);
            t.setHostProp(n, Wi, null);
        }
        e > 0 && pl(n) && kn(t, n);
        return Gi(r(o), t => Gi(i.rn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Hi) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Xi);
        if (o) {
            return function i(t, n, e) {
                const s = Ot(n);
                let o = n;
                const i = "q-e:qvisible";
                return Gi(s, n => {
                    const s = !n;
                    let r = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== i && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    r = Lt();
                                    const n = Ce;
                                    n && t.ct(r) || (o = jt(o, r));
                                }
                                l = r;
                            }
                            if (l) {
                                l.type === "script" && c === i && (u = "q-d:qinit");
                                Nt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (Ji(t) && e < Hi) {
            return t.then(() => u(++e));
        }
        if (e >= Hi) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Nt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const i = e.qrls;
    o == null ? s[n] = i : Array.isArray(o) ? o.push(...i) : s[n] = [ o, ...i ];
    const r = t.varProps[n];
    if (r) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...i ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = rs(n);
    c && Ct(t, f, "capture");
    l && Ct(t, f, "preventdefault");
    u && Ct(t, f, "stoppropagation");
}

function Ct(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === pr && (t.varProps = {});
    t.varProps[s] = !0;
}

function Ot(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Zr(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Qe(t)) {
            n.push(...t);
        } else {
            if (Ji(t)) {
                return Gi(t, t => Ot(t));
            }
            if (qu(t)) {
                return Ot(t.untrackedValue);
            }
        }
    }
    return null;
}

function jt(t, n) {
    if (Zr(t)) {
        if (t.type !== vo && !ma(t.type)) {
            return co(vo, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : Qe(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return co(vo, null, null, [ t, n ], 0, null);
    }
    if (Qe(t) && t.length > 0) {
        jt(t[0], n);
        return t;
    }
    return t;
}

function Lt() {
    return new Gr("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ft(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Dt(t, n, e, s, o, i) {
    const r = Array(i - o + 1);
    for (let c = o; c <= i; c++) {
        const i = n[c] ?? (n[c] = e(t[c], c));
        r[c - o] = Ft(t[c], c, i, s);
    }
    return r;
}

function Xt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Wt(t, n, e, s, o, i, r) {
    const c = t;
    const l = o.length;
    const u = Yl(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Yo(c, n, Dt(o, a, i, r, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Bl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= i(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Yo(c, n, Dt(o, a, i, r, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Bl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= i(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            zl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return Yo(c, n, Dt(o, a, i, r, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= i(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function _(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            zl(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < w; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(w);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let i = 0;
            let r = e.length;
            for (;i < r; ) {
                const s = i + r >> 1;
                t[e[s]] < n ? i = s + 1 : r = s;
            }
            i > 0 && (s[o] = e[i - 1]);
            i === e.length ? e.push(o) : e[i] = o;
        }
        const o = [];
        let i = e[e.length - 1];
        for (;i !== -1; ) {
            o.push(i);
            i = s[i];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let M = d;
    let A = m;
    const I = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                A = g[S[t]];
                M--;
                continue;
            }
            const i = S[t];
            if (i !== -1) {
                const t = g[i];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Wl(n, e, t, A);
                A = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = Yo(c, n, Dt(o, a, null, r, l, M), e, A, A, s, null, !0, f);
            return Gi(d, () => {
                const t = Xt(e, A, u);
                A = t;
                M = l - 1;
                return I();
            });
        }
    };
    return I();
}

function Vt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Oi);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let i = 0; i < s.length; i++) {
        const r = s[i];
        if (r instanceof Ru) {
            const s = r;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const i = !!(s.h & 8);
                const r = ku(s, n, t);
                Ji(r) && (i ? o = o ? o.then(() => r) : r : (e.extraPromises ||= []).push(r));
            }
        }
    }
    return o;
}

function Ut(t, n) {
    const e = t.props ||= {};
    e[ir] = n;
}

function zt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[sr] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[sr] = n;
    })(t, null);
    const i = t;
    const r = i.parent;
    const c = i.nextSibling;
    const l = Nl(n, document, i, e);
    const u = $l(i) && r || i;
    const f = u === i ? null : c;
    Ol(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Bt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let i = function r(t) {
        const n = t.props;
        return n?.[ir];
    }(t);
    if (!i) {
        return;
    }
    Ut(t, null);
    qu(i) && (i = i.value);
    return Jo(n, e, i, o, s, null);
}

function Qt(t, n, e, s) {
    const o = t;
    const i = n.getHostProp(o, ri);
    if (i && !i.resolved) {
        return i.resolve();
    }
    t.dirty &= -5;
    if (!i) {
        return;
    }
    const r = n.getHostProp(o, Ci) || null;
    return Jt(n, o, o, i, r, e, s);
}

function Ht(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const i = function r(t) {
        const n = t.props;
        const e = n?.[or] || null;
        e && delete n[or];
        return e;
    }(t);
    if (!i) {
        return;
    }
    return Jt(n, o, i.subscriptionHost || n.rootVNode, i.componentFn, i.props, e, s);
}

function Jt(t, e, s, o, i, r, c) {
    const l = Yi(() => Ko(t, e, s, o, i), s => {
        const o = t.getHostProp(e, $i);
        return n(() => Jo(t, r, s, e, c, ns(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (Ji(l)) {
        return l;
    }
    return;
}

function Yt(t, n, e, s, o, i = null) {
    n.push(Xo(t.node, e, s, i, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Gt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[er] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        qu(e) && (e = e.value);
        const i = s.isConst;
        Yt(o, n, t, e, i, s.scopedStyleIdPrefix);
    }
    (function i(t) {
        const n = t.props ||= {};
        delete n[er];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Oi);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Ru && n.h & 16) {
            n.h &= -17;
            const t = n;
            Qo(t);
        }
    }
}

function Zt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, rr);
    if (!s) {
        return;
    }
    const o = s.ft;
    const i = xe();
    i.$ = e;
    return Gi(n(() => qe.call(s, i, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Nu(e, s, o);
        }
    });
}

function tn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const i = n.getHostProp(o, Ci) || null;
    if (!i) {
        return;
    }
    let r = vr(i, "items");
    qu(r) && (r = Nf(r));
    const c = vr(i, "key$");
    const l = vr(i, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Wt(n, e, o, s, r, u, f);
    }
    return Gi(c.resolve(), t => Gi(l.resolve(), i => Wt(n, e, o, s, r, t, i)));
}

let Zo = null;

const tl = (t, n, e) => {
    Zo || (Zo = t.insertBefore);
    Zo.call(t, n, e);
};

function nn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                tl(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                tl(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof Co) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                r();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                r();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            tl(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof xo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && r();
            l.target.remove();
            continue;
        }
        if (l instanceof Io) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && r();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof No) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Oo) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? i(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (nl(t, e)) {
                t[e] = el(o);
            } else if (e === Bi) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(Si, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : E(t, e, o, l.isSvg);
            }
        }
    }
    r();
}

const nl = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const el = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const il = (t => () => queueMicrotask(t))(rn);

const rl = hs(rn);

let ol = !1;

function en() {
    if (!ol) {
        ol = !0;
        il();
    }
}

function sn() {
    if (!ol) {
        ol = !0;
        rl();
    }
}

function rn() {
    ol = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (on(e, n)) {
            sn();
            return;
        }
    }
}

function on(t, n) {
    const e = Ce;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const i = s.container;
    if (!t.dirty) {
        ln(i, t, s, e);
        return;
    }
    const r = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(i, s, fn(l, t, i));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, i);
            } else if (l.dirty & 64) {
                const n = cn(i, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(i, s, fn(l, t, i));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Vt(l, i, s);
            } else if (l.dirty & 2) {
                e = Bt(l, i, r, t);
            } else if (l.dirty & 4) {
                e = Qt(l, i, r, t);
            } else if (l.dirty & 8) {
                e = Ht(l, i, r, t);
            } else if (l.dirty & 256) {
                e = tn(l, i, r, t);
            } else if (l.dirty & 16) {
                Gt(l, r);
            } else if (l.dirty & 32) {
                e = Zt(l, i);
            } else if (l.dirty & 64) {
                const n = cn(i, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && zt(l, r);
            }
        } catch (t) {
            i.handleError(t, l);
        }
        if (e && Ji(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, i);
            const o = l;
            n.catch(t => {
                s.promise === n && i.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, i);
                en();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    ln(i, t, s, e);
}

function ln(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                nn(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    ku(s, t, s.ht);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function i(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                un(t);
            });
            return;
        }
        un(t);
    }
}

function un(t) {
    t.dt();
}

function cn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function i(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const r = fn(o[0], s, t);
    p(t, n, r);
    return r;
}

function fn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let i = s.nextDirtyChildIndex;
    const r = o.length;
    let c = r;
    for (;c-- > 0; ) {
        const t = o[i];
        if (t.dirty & 1023) {
            if (e && an(e, t)) {
                i++;
                i === r && (i = 0);
                continue;
            }
            s.nextDirtyChildIndex = (i + 1) % r;
            return t;
        }
        i++;
        i === r && (i = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return fn(s, n, e);
}

function an(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(Ri in n.props) || !t.getHostProp(n, Ri)) {
        return !1;
    }
    dn(n) || hn(t, n, 0);
    return !0;
}

function hn(t, n, e) {
    if (dn(n)) {
        en();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        nr.set(t, n);
    })(n, s);
    const i = n;
    i.flags |= 256;
    l(t, i);
    en();
    return i;
}

function dn(t) {
    return (t.flags & 256) !== 0;
}

function pn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(er);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                qu(e) && (e = e.value);
                const r = i(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && Zt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Oi);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const i = e[o];
                if (i instanceof Ru) {
                    const e = i;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = ku(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        Ji(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, Ci) || null;
            if (!s) {
                return;
            }
            let o = vr(s, "items");
            qu(o) && (o = Nf(o));
            const i = await vr(s, "key$").resolve();
            const r = await vr(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = r(n, t);
                const s = i(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const ll = [];

function $n(t) {
    for (let n = 0; n < ll.length; n++) {
        const e = ll[n];
        const s = ll[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function yn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function i() {
        return Ce;
    }()) {
        const e = pn(t, n);
        Ji(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const r = e & 1023;
    if ((r ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && r && c && !c.dirty) {
        (function e(t, n, s) {
            ll.push(n);
            let o = P(t, n);
            let i = n.slotParent || n.parent;
            for (;i; ) {
                const e = i.dirty & 1023;
                const r = dn(i);
                __EXPERIMENTAL__.suspense && (o ||= P(t, i) || (e ? q(t, i) : null));
                if (i === s || e) {
                    A(n, o);
                    $n(i);
                    if (r) {
                        const t = y(i);
                        t.position !== i && (t.position = n);
                    }
                    ll.length = 0;
                    return;
                }
                if (r) {
                    const t = y(i);
                    t.position !== i && (t.position = n);
                }
                ll.push(i);
                i = i.slotParent || i.parent;
            }
            ll.length = 0;
            ((t, ...n) => {
                const e = De(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        A(n, P(t, n) || q(t, c));
        r && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (r && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (dn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        dn(n) ? A(n, P(t, n)) : function l(t, n) {
            ll.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = dn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? q(t, s) : null));
                if (o) {
                    A(n, e);
                    $n(s);
                    ll.length = 0;
                    return !0;
                }
                ll.push(s);
                s = s.slotParent || s.parent;
            }
            A(n, e);
            ll.length = 0;
            return !1;
        }(t, n) || hn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const ul = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const cl = t => {
    let n = null;
    return e => {
        n || (n = ul(e, t));
        return n.call(e);
    };
};

const fl = (t, n, e = null) => {
    const s = new Gs(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const al = t => {
    const n = new Gs(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const hl = (t, n) => {
    const e = new Ks(-4084, null, null, null, null, t, n);
    return e;
};

const dl = () => {
    const t = new Ys(null, -4094, null, null, null, null, null, null);
    return t;
};

const pl = t => t instanceof Js;

const $l = t => (t.flags & 1) === 1;

const yl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const ml = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const wl = t => (t.flags & 4) === 4;

const vl = t => (t.flags & 2) === 2;

const bl = t => {
    const n = t.flags;
    return (n & 2) === 2 && _l(t, ui, null) !== null;
};

const cd = t => t;

const _l = (t, n, e) => {
    if ($l(t) || vl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const gl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const El = (t, n, e, s, o = null) => {
    if ($l(n)) {
        gl(n, e, s);
        mn(t, Xo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Sl = t => {
    if (t.key) {
        return;
    }
    const n = nu(t.node, zi);
    n && (t.key = n);
};

const kl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let i = !1;
        for (let n = 0; n < o.length; n++) {
            const r = o[n];
            const c = r.name;
            if (es(c)) {
                wn(r, c, t, s);
                continue;
            }
            if (i) {} else if (c !== zi && c) {
                if (c.startsWith(Si)) {
                    const t = r.value;
                    t === "html" ? gl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && gl(e, "value", s.value);
                } else {
                    const t = r.value;
                    gl(e, c, t);
                }
            } else {
                const t = r.value;
                t && (e.key = t);
                i = !0;
            }
        }
        _l(e, Li, null) === null && _l(e, Fi, null) === null || (n.flags |= 64);
    }
};

const Rl = t => {
    if (t._t === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ke(n)) {
            return n;
        }
    }
    return t;
};

function wn(t, n, e, s) {
    const o = t.value;
    const i = n.slice(2);
    const r = o.split("|");
    const c = [];
    for (let t = 0; t < r.length; t++) {
        const n = Rl(Ln(r[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[i] = c.length === 1 ? c[0] : c;
}

function vn(t, n, e) {
    let s = Yl(n);
    for (;s; ) {
        if (wl(s)) {
            Tl(t, s);
            e(s, n);
        } else {
            $l(s) ? e(s, n) : vn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function bn(t) {
    let n = t;
    if (wl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Yl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Pl = (t, n, e) => {
    let s = t;
    for (;e && s && vl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !vl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !vl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (wl(t) && e && $l(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && mu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Tl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Vl(n, !0);
        const o = e.node;
        const i = au(s);
        let r = Pl(n, !1, !0);
        const c = Pl(n, !0, !0);
        const l = o || (c && $l(c) ? c.node : c?.node) || null;
        let u = l;
        for (;r && wl(r); ) {
            if ((r.flags & 8) === 0) {
                const n = i.createTextNode(r.text);
                mn(t, Do(n, s, u));
                u = n;
                r.node = n;
                r.flags |= 8;
            }
            r = Pl(r, !1, !0);
        }
        r = n;
        for (;r && wl(r); ) {
            const n = Pl(r, !0, !0);
            const e = !n || !wl(n);
            if ((r.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Fo(o, r.text));
                } else {
                    const n = i.createTextNode(r.text);
                    mn(t, Do(n, s, l));
                    r.node = n;
                }
                r.flags |= 8;
            }
            r = n;
        }
    }
};

const ql = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let i = -1;
    let r;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        i = parseInt(c);
        r = o.get(i);
    } else {
        r = n;
        const t = r;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = al(r);
            Sl(e);
            t.vNode = e;
            return e;
        }
    }
    if (pl(r)) {
        e = r;
    } else {
        if (__EXPERIMENTAL__.suspense && r._qSegment) {
            e = r.vNode || al(r);
            Sl(e);
        } else {
            let t = r;
            const n = [ r ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = xl(e, n[t]);
            }
        }
        if (i != -1) {
            r.vNode = e;
            o.set(i, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Il(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = Al(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const Al = (t, n) => {
    let e = Yl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Ml = [];

const xl = (t, n) => {
    let e = Yl(t);
    for (;e && (!(e instanceof Gs) || e.node !== n); ) {
        if (vl(e)) {
            const t = e.nextSibling;
            const n = Yl(e);
            if (n) {
                t && Ml.push(t);
                e = n;
            } else {
                e = t || (Ml.length ? Ml.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Ml.pop();
        }
    }
    for (;Ml.length; ) {
        Ml.pop();
    }
    return e;
};

const Il = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Nl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const i = fl(o, "errored-host");
    if (yl(e)) {
        Wl(t, i, e, null);
    } else {
        const n = [];
        vn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Wl(t, i, n[e], null);
        }
    }
    return i;
};

const Cl = nn;

const Ol = (t, n, e, s) => {
    const o = $l(n);
    o && Gl(n);
    const i = e.parent;
    if (e === s) {
        if (i) {
            return;
        }
        s = null;
    }
    Dl(t, i, n, e);
    const r = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Vl(n, !1);
    l && !c && mn(t, Do(r, l, Ll(t, n, s)?.node ?? null));
    Fl(n, e, s);
    c && (e.flags |= 32);
};

const jl = (t, n, e, s) => {
    const i = $l(n);
    i && Gl(n);
    const c = e.parent;
    if (e === s) {
        if (c) {
            return;
        }
        s = null;
    }
    Dl(t, c, n, e);
    const l = n.flags & 32;
    const u = !i && n.flags & 2048 ? n.props?.[oi] : null;
    const f = u ? null : i ? n : Ul(n, !1);
    const a = u || f?.node;
    const h = Ll(t, n, s);
    const d = h?.node ?? null;
    const p = bl(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Ul(n, !1);
        const c = Ll(t, n, s)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(i, e);
        vn(t, e, n => {
            if (wl(n)) {
                mn(t, Do(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, s, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if ($l(c)) {
                                e = c.node;
                                const t = Ql(c);
                                const l = c.parent;
                                const h = u == null ? n : l && Ul(l, !0);
                                if (h) {
                                    const t = o(h, Ql(c));
                                    s = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Yl(c);
                                a = r(e, t, s, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Zl(e)) {
                                    const t = Se(e);
                                    if (t) {
                                        const n = Yl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, i, l, u);
                    t && (n.node = t);
                }
                mn(t, Do(n.node, a, c));
            }
        });
    } else {
        a && !l && vn(t, e, n => {
            mn(t, Do(n.node, a, d));
        });
    }
    Fl(n, e, s);
    l && (e.flags |= 32);
};

const Ll = (t, n, e) => {
    let s = null;
    e == null ? vl(n) && (s = Pl(n, !0, !1)) : s = vl(e) ? Pl(e, !0, !0) : e;
    s && wl(s) && Tl(t, s);
    return s;
};

const Fl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Dl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && zl(t, n, s, !1);
};

const Xl = (t, n) => {
    let e = n;
    for (;e && vl(e); ) {
        e = e.lastChild;
    }
    e && wl(e) && (e.flags & 8) === 0 && Tl(t, e);
};

const Wl = (t, n, e, s) => {
    yl(e) ? Ol(t, n, e, s) : jl(t, n, e, s);
};

const Vl = (t, n) => {
    for (;t && !$l(t); ) {
        if (t.flags & 2048) {
            return t.props?.[oi];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Ul = (t, n) => {
    for (;t && !$l(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const zl = (t, n, e, s) => {
    wl(e) && Tl(t, e);
    if (s) {
        const s = _l(n, Bi, null) !== null;
        if (s) {
            return;
        }
        yl(e) ? mn(t, jo(e.node)) : vn(t, e, n => {
            mn(t, jo(n.node));
        });
    }
    const o = e.previousSibling;
    const i = e.nextSibling;
    o ? o.nextSibling = i : n.firstChild = i;
    i ? i.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Bl = (t, n, e, s = !0) => {
    const o = Vl(n, !0);
    if (o && s) {
        if (yl(n)) {
            mn(t, Lo(n.node));
        } else {
            const e = Ul(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, Lo(o)) : vn(t, n, n => {
                mn(t, jo(n.node));
            });
        }
    }
    const i = e.previousSibling;
    i ? i.nextSibling = null : n.firstChild = null;
    n.lastChild = i;
};

const Ql = t => {
    const n = cd(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = fu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = cu(t);
            switch (n) {
              case Ai:
                return 512;

              case Mi:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Hl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Jl = (t, n, e) => {
    Tl(t, n);
    n.text = e;
    mn(t, Fo(n.node, e));
};

const Yl = t => {
    if (wl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && $l(t) && function e(t) {
        const n = t.getAttribute(ed);
        if (n === null) {
            return !1;
        }
        const e = uu(t);
        return gu(e) && e.localName === "template" && e.getAttribute(ai) === n && ru(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Gl(t));
    return n;
};

const Gl = n => {
    const e = cd(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && Zl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = uu(e);
            const o = au(e)?.qVNodeData?.get(e);
            const i = ((n, e, s, o) => {
                Sl(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === ii && o.charCodeAt(1) === ii) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const i = hu(n, s, e);
                        if (!o) {
                            return i;
                        }
                    }
                    return function i(n, e, s, o) {
                        let i = 0;
                        let r = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | i << 12;
                            i++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            r || (n.firstChild = r = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = gu(t);
                            return !n || n && Sn(t);
                        };
                        let p = null;
                        du(e, ($, y, m, w, b) => {
                            if (wu($())) {
                                for (;d(o); ) {
                                    o = ru(o);
                                    if (!o) {
                                        throw Ye(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;wu($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = al(o);
                                    Sl(n);
                                    u(n);
                                    o = ru(o);
                                    for (;gu(o) && Sn(o); ) {
                                        o = ru(o);
                                        if (!o && t > 0) {
                                            throw Ye(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                gl(n, $i, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                gl(n, ri, y());
                            } else if ($() === 61) {
                                h || (h = Ee(s));
                                const t = y();
                                h.zn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                gl(n, Ci, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === ii;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                gl(n, Oi, y());
                            } else if ($() === 94) {
                                gl(n, ji, y());
                            } else if ($() === 96) {
                                h || (h = Ee(s));
                                gn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = Ee(s));
                                n.slotParent = ql(h.rootVNode, y());
                            } else if ($() === 93) {
                                gl(n, yi, y());
                            } else if ($() === 123) {
                                m();
                                u(dl());
                                bu.push(n, r, c, l, i);
                                i = 0;
                                n = c;
                                r = c = null;
                            } else if ($() === ii) {
                                const e = y();
                                const s = t(e);
                                const o = b + e.length + 1;
                                const i = w(o + 1) === ii;
                                let r;
                                if (i) {
                                    m();
                                    r = decodeURI(t(y()));
                                    m();
                                } else {
                                    r = t(y());
                                }
                                gl(n, s, r);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                i = bu.pop();
                                l = bu.pop();
                                c = bu.pop();
                                r = bu.pop();
                                n = bu.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                gl(n, ui, e);
                            } else {
                                for (;gu(o) && Sn(o); ) {
                                    o = ru(o);
                                }
                                const t = o && eu(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;vu($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Ks(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Ee(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return r;
                    }(n, o, e, s);
                }
                return hu(n, s, void 0);
            })(n, e, s, o);
            return i;
        })(e);
    }
    return s;
};

let Kl = null;

const Zl = t => {
    Kl || (Kl = t.hasAttribute);
    return Kl.call(t, Si);
};

let tu = null;

const nu = (t, n) => {
    tu || (tu = t.getAttribute);
    return tu.call(t, n);
};

const eu = cl("nodeType");

const iu = t => {
    const n = eu(t);
    return n === 3 || n === 1;
};

let su = null;

const ru = t => {
    su || (su = ul(t, "nextSibling"));
    lu || (lu = ul(t, "firstChild"));
    for (;t; ) {
        t = su.call(t);
        if (t !== null) {
            const n = eu(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(gi)) {
                    return _n(t, bi, su, lu);
                }
                if (t.nodeValue?.startsWith(_i)) {
                    return _n(t, [ bi, Ei ], su, lu);
                }
                if (n?.startsWith(Si)) {
                    for (;t && (t = su.call(t)) && (eu(t) !== 8 || !t.nodeValue?.startsWith(ki)); ) {}
                }
            }
        }
    }
    return t;
};

function _n(t, n, e, s) {
    const o = typeof n === "string";
    const i = n.length;
    for (;t; ) {
        const r = t.nodeValue;
        let c;
        if (o) {
            c = r?.startsWith(n);
        } else {
            for (let t = 0; t < i; t++) {
                if (r?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = ou(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const ou = cl("parentNode");

let lu = null;

const uu = t => {
    lu || (lu = ul(t, "firstChild"));
    t = t && lu.call(t);
    if (t && eu(t) === 8) {
        su || (su = ul(t, "nextSibling"));
        if (t.nodeValue?.startsWith(gi)) {
            return _n(t, bi, su, lu);
        }
    }
    for (;t && !iu(t); ) {
        t = ru(t);
    }
    return t;
};

const cu = cl("namespaceURI");

const fu = cl("nodeName");

const au = cl("ownerDocument");

const hu = (t, n, e) => {
    let s = null;
    let o = 0;
    const i = () => {
        for (;gu(r) && Sn(r); ) {
            r = ru(r);
        }
    };
    let r = n;
    i();
    let c = null;
    for (;r; ) {
        const n = eu(r);
        let e = null;
        if (n === 3) {
            e = hl(r, r.textContent ?? void 0);
        } else if (n === 1) {
            e = al(r);
            Sl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        r = ru(r);
        i();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        du(e, (e, s) => {
            if (e() === 61) {
                n || (n = Ee(t.node));
                const e = s();
                n.zn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Ee(t.node));
                gn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function gn(t, n, e) {
    if (t[Vs]) {
        const s = t[Vs];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, Vs, {
            get() {
                const s = e._(n);
                t[Vs] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Vs, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const du = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const i = n => n < t.length ? t.charCodeAt(n) : 0;
    const r = () => o !== 0 ? o : o = i(e);
    const c = () => {
        s = r();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;r() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;r() !== 0; ) {
        n(r, l, c, i, e);
    }
};

const pu = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        kl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(zi) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const $u = (t, n) => {
    let e = yu(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = yu(e);
    }
    return !1;
};

const yu = t => t.parent || t.slotParent;

const mu = t => {
    if (t === null || vl(t)) {
        return null;
    }
    return t.node;
};

function En(t = 20, n = "", e = !1, s = !1, o = !0, i = null) {
    if (this && !i) {
        try {
            i = function t(n) {
                let e = n;
                for (;e; ) {
                    if ($l(e)) {
                        const t = ke(e.node);
                        if (!t) {
                            return null;
                        }
                        return Se(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let r = this;
    if (t === 0) {
        return "...";
    }
    if (r === null) {
        return "null";
    }
    if (r === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (wl(r)) {
            c.push(Mn(Hl(r)));
        } else if (vl(r)) {
            const e = r.flags >>> 12;
            const s = [ "[" + e + "]" ];
            r.dirty && s.push(" dirty:" + r.dirty);
            if (i) {
                const t = pu(i, r);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Ze && e !== "__scopedStyleIdPrefix__") {
                        const t = _l(r, e, null);
                        s.push(" " + e + "=" + Mn(t));
                    }
                }
                r.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (ti[_l(r, Ze, null) || "V"] || ti.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Yl(r);
            u && c.push("  " + En.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if ($l(r)) {
            const s = Ql(r);
            const l = [];
            dn(r) && l.push(" cursor");
            r.dirty && l.push(" dirty:" + r.dirty);
            r.dirtyChildren && l.push(` dirtyChildren[${r.dirtyChildren.length}]`);
            const u = i ? pu(i, r) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = _l(r, n, null);
                l.push(" " + n + "=" + Mn(e));
            }
            const f = mu(r);
            if (f) {
                const t = au(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Mn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Mn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (ml(r) || e) {
                const e = Yl(r);
                e && c.push("  " + En.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        r = s && r.nextSibling || null;
    } while (r);
    return c.join("\n" + n);
}

const wu = t => 48 <= t && t <= 57;

const vu = t => 97 <= t && t <= 122;

function Sn(t) {
    return !t.hasAttribute(zi) || t.nodeName === "STYLE" && (t.hasAttribute($i) || t.hasAttribute(hi));
}

const bu = [];

const _u = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Ye(26, [ n ]);
};

const gu = t => t && typeof t == "object" && eu(t) === 1;

const Eu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!vl(t) || _l(t, ri, null) === null); ) {
            const e = t.slotParent;
            const s = vl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function kn(t, n) {
    pl(n) && $l(n) && Gl(n);
    const e = n[Vs];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Rn(t, n);
    }
    e.clear();
}

function Rn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof qr) {
            Pn(t, s, n);
            s instanceof Mr && Tn(s, n);
        } else if (gr(s)) {
            const t = s[fr];
            qn(t, n);
        } else if (t.$t.has(s)) {
            const e = t.$t.get(s);
            const o = Du(e);
            qn(o, n);
        }
    }
    e.clear();
}

function Pn(t, n, e) {
    const s = n.ft;
    s && s.has(e) && s.delete(e);
    if (n instanceof Jr && !s?.size) {
        n.m = void 0;
        kn(t, n);
    }
}

function Tn(t, n) {
    const e = t.yt;
    e && e.has(n) && e.delete(n);
    const s = t.wt;
    s && s.has(n) && s.delete(n);
    t.vt();
}

function qn(t, n) {
    const e = t?.ft;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Su = (t, n) => {
    const {val: e, set: s, iCtx: o, i} = Wo();
    if (e) {
        return;
    }
    s(1);
    const r = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Ru(6 | r, i, o.m, t, null);
    s(c);
    const l = o.$;
    const {rn: u} = o;
    const f = Gi(u, () => ku(c, l, o.m));
    Ji(f) && (o.rn = f);
};

const ku = (t, n, e) => {
    const s = t.Bn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let i = null;
    const r = Gi(((t, n) => {
        const e = t.Qn;
        if (e) {
            return e;
        }
        const s = t.un;
        if (!s) {
            return;
        }
        t.un = null;
        try {
            const e = s();
            if (Ji(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Qn === s && (t.Qn = void 0);
                });
                t.Qn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = xe(n.nn, e, "qTask");
        s.$ = n;
        const r = t.bt.getFn(s, () => kn(n, t));
        const c = Tr(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.un = () => {
                            t.un = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    Ji(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Yi(() => r(u), l, s => {
            if (Ji(s)) {
                return s.then(() => {
                    t.Bn === i && (t.Bn = null);
                    return ku(t, n, e);
                });
            }
            o(s);
        });
    });
    if (Ji(r)) {
        i = r.finally(() => {
            t.Bn === i && (t.Bn = null);
        });
        t.Bn = i;
        return i;
    }
    return r;
};

class Ru extends Us {
    h;
    Nt;
    ht;
    bt;
    un;
    Qn;
    Bn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Nt = n;
        this.ht = e;
        this.bt = s;
        this.un = o;
    }
}

const Pu = t => t instanceof Ru;

function An(t, n) {
    const e = Ee(n);
    return Rf(e, () => {
        typeof this === "string" && Kf(Zf(e, this));
        const t = Gf[0];
        t.h |= 4;
        yn(e, t.ht, 1);
    });
}

const Tu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const qu = t => t instanceof qr;

const Au = (t, n) => {
    t.add(n);
};

const Mu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const xu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Pu(e) ? o = e.bt : e instanceof Mr ? o = e.Ot : s === ":" && (o = n.getHostProp(e, ri));
        o && n.serializationCtx.It.add(o);
    }
};

const Iu = (t, n) => {
    if (t && (!n || t === n || rd(t))) {
        return t;
    }
    return n;
};

const Nu = (t, n, e) => {
    const s = Oe;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const i = e.property;
            if (Pu(o)) {
                o.h |= 4;
                yn(t, o.ht, 1);
            } else if (o instanceof qr) {
                o.invalidate();
            } else if (i === ":") {
                yn(t, o, 4);
            } else if (i === ".") {
                if (s) {
                    Ut(o, n);
                    yn(t, o, 2);
                }
            } else {
                const r = e.data;
                if (r instanceof Yr) {
                    const e = r.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[er];
                            if (!o) {
                                o = new Map;
                                s[er] = o;
                            }
                            o.set(n, e);
                        })(o, i, c);
                    } else {
                        const t = o;
                        let n = t.getProp(er);
                        if (!n) {
                            n = new Map;
                            t.setProp(er, n);
                        }
                        n.set(i, c);
                    }
                    yn(t, o, 16);
                }
            }
        };
        const i = Array.from(e);
        for (let t = 0; t < i.length; t++) {
            o(i[t]);
        }
    }
};

const Cu = t => Be(t) && typeof t[df] === "function";

const Ou = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const ju = t => {
    t.h |= 4;
};

const Lu = [];

function Mn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Pu(t)) {
            return `Task(${Mn(t.bt)})`;
        }
        if (Ke(t)) {
            return `Qrl(${t._t})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Lu.includes(t)) {
                return "*";
            }
            Lu.length;
            try {
                Lu.push(t);
                if (Array.isArray(t)) {
                    return pl(t) ? "(" + (_l(t, Ze, null) || "vnode") + ")" : t.map(Mn);
                }
                if (qu(t)) {
                    return t instanceof Jr ? "WrappedSignal" : t instanceof Mr ? "ComputedSignal" : "Signal";
                }
                if (zu(t)) {
                    return "Store";
                }
                if (Zr(t)) {
                    return Fu(t);
                }
                if (pl(t)) {
                    return "(" + (_l(t, Ze, null) || "vnode") + ")";
                }
            } finally {
                Lu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Fu = t => {
    if (Zr(t)) {
        if (typeof t.type === "function") {
            const n = t.type[ya];
            if (n) {
                const [t] = n;
                return "Component(" + t._t + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Mn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Fu(e);
                    }
                } else {
                    n += Fu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Du = t => t[Rr];

const Xu = t => t?.[kr] || null;

const Wu = (t, n) => {
    const e = Du(t);
    e && e.force(n);
};

const Vu = (t, n) => {
    const e = Du(t);
    if (e) {
        return (e.ft?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Uu = t => Xu(t) || t;

const zu = t => kr in t;

function xn(t, n, e) {
    return new Proxy(n, new Qu(e, t || null));
}

const Bu = (t, n, e) => {
    if (ze(t) && e) {
        let s = e.$t.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.$t.set(t, s);
        }
        return s;
    }
    return t;
};

class Qu {
    h;
    $;
    ft=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Xu(this);
        Nu(this.$, this, Cn(n, t, this.ft));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === kr) {
                return t;
            }
            if (n === Rr) {
                return this;
            }
            return t[n];
        }
        const e = Af();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.sn;
            o && In(t, Array.isArray(t) ? Pr : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && Be(s) && !Object.isFrozen(s) && !zu(s) && !Object.isFrozen(t)) {
            return Bu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Uu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Nn(n, s, t, this);
        } else {
            Nn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Nu(this.$, this, Cn(t, n, this.ft));
        return !0;
    }
    has(t, n) {
        if (n === kr) {
            return !0;
        }
        if (typeof n === "string") {
            const e = Af();
            if (e) {
                const s = e.sn;
                s && In(t, Array.isArray(t) ? Pr : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = Af();
        const e = n?.sn;
        e && In(t, Pr, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function In(t, n, e, s, o) {
    const i = e.ft ||= new Map;
    let r = i.get(n);
    if (!r) {
        r = new Set;
        i.set(n, r);
    }
    const c = Ce;
    const l = __EXPERIMENTAL__.suspense && e instanceof Qu && c;
    Au(r, s);
    Mu(s, t);
    if (c) {
        const r = Iu(o, e.$);
        l && r?.bn?.(t, s, n, i);
        xu(s, r);
    }
}

function Nn(t, n, e, s) {
    e[t] = n;
    const o = Cn(e, t, s.ft);
    o && Nu(s.$, s, o);
}

function Cn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Pr);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Hu = Symbol();

const Ju = [ void 0, null, !0, !1, "", dr, pr, Er, Pr, hr, _o, vo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const Yu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const Gu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function On(t, n, e) {
    let s = n._t;
    let o = n.gt;
    const i = ms();
    if (i) {
        const t = i.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const r = (t => Ke(t) && t._t == Ge)(n);
    if (r) {
        const e = n.resolved;
        o = "";
        s = t.Et(null, 0, e) + "";
    } else {
        o || (o = t.St(n.rt));
        if (!o) {
            throw Ye(14, [ n._t ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.kt(c[s]);
            const i = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + i;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function jn(t, n, e, s) {
    return ia(t, n, null, null, e, s);
}

function Ln(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const i = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const r = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return jn(o, i, r, n);
}

class Ku {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Zu {
    Jn;
    Yn=0;
    Pt=[];
    Gn=0;
    Kn=new Set;
    Zn=new Map;
    te;
    ne=new Map;
    ee=0;
    Vt;
    ie=typeof Temporal !== "undefined";
    constructor(t) {
        this.Jn = t;
        this.Vt = t.Vt;
    }
    async serialize() {
        const t = this.ee;
        this.ee = 0;
        try {
            await this.outputRoots();
        } finally {
            this.ee = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.ee;
        this.ee = s;
        this.Vt.write(Ls);
        this.Jn.se = 0;
        try {
            this.Vt.write(t + "");
            this.Vt.write(Ds);
            this.Vt.write(Ls);
            await this.outputSelectedRoots(n);
            this.Vt.write(Fs);
            const s = this.getForwardRefsPayload();
            this.Jn.se = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Vt.write(Ds);
                s ? this.outputForwardRefsArray(s) : this.Vt.write("0");
            }
            if (e !== void 0) {
                this.Vt.write(Ds);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Vt.write(js);
                    this.writeRootRefPath(e);
                    this.Vt.write(js);
                }
            }
        } finally {
            this.ee = o;
        }
        this.Vt.write(Fs);
    }
    re(t) {
        this.Vt = t;
    }
    outputArray(t, n, e) {
        this.Vt.write(Ls);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Vt.write(Ds) : s = !0;
            e(t[n], n);
        }
        this.Vt.write(Fs);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : js + t + js;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Vt.write(n.slice(s, e));
            this.Vt.write("<\\/");
            s = e + 2;
        }
        this.Vt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Vt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Vt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Vt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Vt.write(js);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Vt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Vt.write(js);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Vt.write(t + Ds);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Vt.write(js);
                this.writeRootRefPath(n);
                this.Vt.write(js);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Vt.write(t + Ds);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Vt.write(t + Ds + n);
        } else if (typeof n === "string") {
            this.Vt.write(t + Ds);
            this.outputString(n);
        } else {
            this.Vt.write(t + Ds);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Jn.getSeenRef(t);
        const o = !e && this.Zn.get(t);
        if (s) {
            s.te && this.isSeenInStreamedRoot(s) && (s = this.Jn.oe(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Jn.le(t, this.te, n);
            }
            s = this.Jn.kt(t, !0);
        }
        if (s.te) {
            if (this.te) {
                this.Jn.ue(s, t);
            } else {
                this.Jn.ue(s, t, n);
                t = this.Jn.ce[n];
            }
        }
        if (typeof o === "number") {
            this.Pt[o] = s.Nt;
            this.Zn.delete(t);
        }
        const i = t instanceof cc ? t.fe : s.Nt;
        if (!this.te && i === n) {
            return s;
        }
        this.output(1, i);
    }
    isSeenInStreamedRoot(t) {
        for (;t.te; ) {
            t = t.te;
        }
        return t.Nt < this.ee;
    }
    writeValue(t, n) {
        if (ff(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === Er) {
                    this.output(3, 7);
                } else if (t === Pr) {
                    this.output(3, 8);
                } else if (t === hr) {
                    this.output(3, 9);
                } else {
                    if (t !== Hu) {
                        throw Ye(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === _o) {
                    this.output(3, 10);
                } else if (t === vo) {
                    this.output(3, 11);
                } else if (Ke(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = On(this.Jn, t, !0);
                        let o;
                        if (n !== "") {
                            const i = this.Jn.kt(n);
                            const r = this.Jn.kt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(r, s) : null;
                            o = [ i, "#", {
                                id: r,
                                base: i
                            } ];
                            if (s) {
                                let t = 0;
                                let n = r;
                                let e = 0;
                                o.push("#");
                                for (let i = 0; i <= s.length; i++) {
                                    if (i === s.length || s[i] === " ") {
                                        if (i > e) {
                                            const r = t + +s.slice(e, i);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: r,
                                                base: n
                                            });
                                            t = r;
                                            n = r;
                                        }
                                        e = i + 1;
                                    }
                                }
                            }
                            const l = `${i}#${r - i}${c ? "#" + c : ""}`;
                            const u = this.ne.get(l);
                            if (u) {
                                const t = this.Jn.kt(u);
                                this.output(1, t);
                                return;
                            }
                            this.ne.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!ma(t)) {
                        throw Ye(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[ya];
                        this.Jn.ae.add(n._t);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === dr) {
                    this.output(3, 5);
                } else if (t === pr) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof cc) {
                    this.output(1, t.fe);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.te;
                        this.te = e;
                        this.writeObjectValue(t);
                        this.te = n;
                    }
                }
                break;

              default:
                throw Ye(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (gr(t)) {
            const n = t[cr];
            this.output(38, [ lc(n), n.varProps, n.constProps, t[fr].ft ]);
        } else if (t instanceof Yr) {
            const {O: n, et: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof Sr) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Ku) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (zu(t)) {
            const n = Du(t);
            const e = Xu(t);
            const s = n.h;
            const o = n.ft;
            const i = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Jn.$t.get(n);
                s && i.push(s);
            }
            const r = [ e, s, o, ...i ];
            for (;r[r.length - 1] === void 0; ) {
                r.pop();
            }
            this.output(35, r);
        } else if (Cu(t)) {
            const n = t[df](t);
            if (Ji(n)) {
                const t = this.resolvePromise(n, (t, n) => new tc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.te.Nt;
                this.te = this.te.te;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        ff(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Jn.he(t)) {
            this.Jn.de(t.pe, 16);
            this.output(11, t.pe.id);
        } else if (t instanceof qr) {
            if (t instanceof Ir) {
                const n = function e(t, n) {
                    if (n === Er) {
                        return n;
                    }
                    return Gi(t.Ot.resolved || t.Ot.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && df in n && (e = n[df](n));
                        e === void 0 && (e = Er);
                        return e;
                    });
                }(t, t.Ct);
                if (Ji(n)) {
                    const e = this.resolvePromise(n, (n, e) => new tc(34, n, e, t.ft, t.Ot));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Ot, t.ft, n ]);
                }
                return;
            }
            if (t instanceof Jr) {
                this.output(31, [ ...Fn(this.Jn, t), t.h, t.m, ...t.ft || [] ]);
            } else if (t instanceof Mr) {
                let n = t.Ct;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const i = ff(t.Ct);
                const r = !!(t.h & 512);
                const c = r && !!t.jt;
                const l = r && t.Tt !== 0 ? t.Tt : void 0;
                const u = r && t.Ft !== 1 ? t.Ft : void 0;
                const f = r && t.Xt !== 0 ? t.Xt : void 0;
                const a = r && t.h & -25 || void 0;
                o || i || c ? n = Er : e ? n = t.Ct : s && (n = Er);
                const h = [ t.Ot, t.ft ];
                if (r) {
                    h.push(t.yt, t.wt, t.jt);
                    h.push(a || void 0);
                }
                n === Er && l === void 0 && u === void 0 && f === void 0 || h.push(n === void 0 ? Hu : n);
                if (r) {
                    h.push(l);
                    h.push(u);
                    h.push(f);
                }
                this.output(r ? 33 : 32, h);
            } else {
                const n = t.Ct;
                const e = [ n === void 0 ? Hu : n ];
                t.ft && e.push(...t.ft);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.Jn.$e(t)) {
            const n = this.Jn.kt(t);
            this.Jn.ye(t, Ii, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                nc(e, t => {
                    this.Jn.kt(t);
                });
                this.Jn.de(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Jn.de(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Zr(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Ru) {
            const n = [ t.bt, t.h, t.Nt, t.ht ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (Ji(t)) {
            const n = this.resolvePromise(t, (t, n) => new tc(24, t, n));
            this.output(2, n);
        } else if (t instanceof tc) {
            if (t.me === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ft, t.we ]);
                } else {
                    if (!t.ve) {
                        console.error(t.we);
                        throw Ye(33);
                    }
                    {
                        const n = this.te.Nt;
                        this.te = this.te.te;
                        this.writeValue(t.we, n);
                    }
                }
            } else {
                this.output(24, [ t.ve, t.we ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof oc) {
            const n = t.be;
            if (this.getSeenRefOrOutput(n, this.te.Nt, !0)) {
                let t = this.Zn.get(n);
                if (t === void 0) {
                    t = this.Gn++;
                    this.Zn.set(n, t);
                    this.Pt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.ie && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.ie && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.ie && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.ie && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.ie && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.ie && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.ie && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.ie && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!pl(t)) {
                throw Ye(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Gn++;
        t.then(s => {
            this.Kn.delete(t);
            this.Pt[e] = this.Jn.kt(n(!0, s));
        }).catch(s => {
            this.Kn.delete(t);
            this.Pt[e] = this.Jn.kt(n(!1, s));
        });
        this.Kn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Jn._e + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {ce: n} = this.Jn;
        for (;this.Yn < n.length || this.Kn.size; ) {
            let e = t > 0;
            for (;this.Yn < n.length; this.Yn++) {
                e ? this.Vt.write(Ds) : e = !0;
                this.writeValue(n[this.Yn], this.Yn);
                t++;
            }
            if (this.Kn.size) {
                try {
                    await Promise.race(this.Kn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Kn.size; ) {
            if (e < t.length) {
                n ? this.Vt.write(Ds) : n = !0;
                const s = t[e++];
                this.writeValue(this.Jn.ce[s], s);
                continue;
            }
            try {
                await Promise.race(this.Kn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Pt.length - 1;
        for (;t >= 0 && this.Pt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Pt.length - 1 ? this.Pt : this.Pt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Vt.write(js);
                this.writeRootRefPath(t);
                this.Vt.write(js);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Vt.write(Ls);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Jn.ge = this.Jn.ce.length;
        this.Jn.Ee = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Vt.write(Ds);
            this.Vt.write(14 + Ds);
            this.outputForwardRefsArray(n);
        }
        this.Vt.write(Fs);
        this.Jn.Se = this.Jn.ce.length + (this.Jn.Ee ? 1 : 0);
        this.Jn.se = e;
    }
}

class tc {
    me;
    ve;
    we;
    ft;
    bt;
    constructor(t, n, e, s, o) {
        this.me = t;
        this.ve = n;
        this.we = e;
        this.ft = s;
        this.bt = o;
    }
}

const nc = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (ec(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === Ii || t === Ci && (Cs(s) || ic(e, s))) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const ec = t => typeof t === "object" && t !== null && !Cs(t);

const ic = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, ri)) {
        return !1;
    }
    const s = n[cr];
    return Cs(s.varProps) && !sc(n) && !rc(t[mi]);
};

const sc = t => !!t[fr].ft?.size;

const rc = t => t instanceof Map && t.has(":");

function Fn(t, n) {
    n.Rt && n.Rt[0] === "{" && (n.Rt = `(${n.Rt})`);
    const e = t.Et(n.Rt, n.ut.length, n.lt);
    return [ e, n.ut ];
}

class oc {
    be;
    constructor(t) {
        this.be = t;
    }
}

const lc = t => new oc(t);

let uc = () => !1;

class cc {
    fe;
    constructor(t) {
        this.fe = t;
    }
}

class fc {
    NodeConstructor;
    DomRefConstructor;
    St;
    ye;
    $t;
    Vt;
    ke=new Map;
    Re=new Map;
    Pe=0;
    Te=[];
    ce=[];
    qe=[];
    Ae;
    _e=0;
    Se=0;
    se=0;
    ge=0;
    Ee=!1;
    qt=new Set;
    It=new Set;
    xt=new Set;
    ae=new Set;
    Me;
    de=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, i) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this.ye = s;
        this.$t = o;
        this.Vt = i;
        this.Me = new Zu(this);
    }
    async Wt() {
        await this.Me.serialize();
    }
    async xe(t, n, e, s) {
        await this.Me.serializePatch(t, n, e, s);
    }
    re(t) {
        this.Vt = t;
        this.Me.re(t);
    }
    getSeenRef(t) {
        return this.ke.get(t);
    }
    le(t, n, e) {
        const s = {
            Nt: e,
            te: n
        };
        this.ke.set(t, s);
        return s;
    }
    Ie(t) {
        const n = [];
        for (;t.te; ) {
            n.unshift(t.Nt);
            t = t.te;
        }
        n.unshift(t.Nt);
        return n;
    }
    ue(t, n, e) {
        const s = this.Ie(t);
        const o = e === void 0;
        e === void 0 && (e = this.ce.length);
        this.ce[e] = new cc(s);
        o && (this.qe[e] = n);
        t.te = null;
        t.Nt = e;
        o && this.Ae?.(e, this.ce[e], n);
    }
    kt(t, n = !1) {
        let e = this.ke.get(t);
        let s;
        if (e) {
            e.te && this.ue(e, t);
            s = e.Nt;
        } else {
            s = this.ce.length;
            e = {
                Nt: s
            };
            this.ke.set(t, e);
            this.ce.push(t);
            this.qe.push(t);
            this.Ae?.(s, t, t);
        }
        return n ? e : s;
    }
    oe(t) {
        const n = this.ce.length;
        const e = {
            Nt: n
        };
        this.ke.set(t, e);
        this.ce.push(t);
        this.qe.push(t);
        this.Ae?.(n, t, t);
        return e;
    }
    Ne(t, n) {
        const e = this.ce.length;
        const s = {
            Nt: e
        };
        this.ke.set(n, s);
        this.ce.push(t);
        this.qe.push(n);
        return e;
    }
    $e(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    he(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Ce(t) {
        const n = this.ke.get(t);
        return n && (n.te ? void 0 : n.Nt);
    }
    Et(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.Re.get(t);
        if (o === void 0) {
            o = this.Pe + this.Te.length;
            this.Re.set(t, o);
            if (s) {
                this.Te.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Te.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Oe(t, n) {
        this.Pe = t;
        if (n) {
            this.Re.clear();
            for (let t = 0; t < n.length; t++) {
                this.Re.set(n[t], t);
            }
        }
    }
}

const ac = (t, n, e, s, o, i) => {
    if (!i) {
        const t = [];
        i = Object.assign(Os(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    uc = n ? t => t instanceof n : () => !1;
    return new fc(t, n, e, s, o, i);
};

const hc = (t, n) => t[n];

const dc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        zu(t) && (t = Xu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!dc(Nf(hc, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!dc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Pu(t)) {
            return !0;
        }
        if (gr(t)) {
            return !0;
        }
        if (Ji(t)) {
            return !0;
        }
        if (Zr(t)) {
            return !0;
        }
        if (Cu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Yr) {
            return !0;
        }
        if (uc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ke(t) || ma(t) || t === _o || t === vo) {
            return !0;
        }
    } else if (t === hr || t === Er || t === Pr) {
        return !0;
    }
    return !1;
};

const pc = (t, n) => {
    let e = pl(t) ? En.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Be(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let $c = !1;

const yc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const i = n ? "[0m" : "";
    const r = e === "";
    const c = [];
    for (let r = 0; r < t.length; r++) {
        if (s && r > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[r];
        let u = t[++r];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && ($c = !0);
            const n = `{${Be(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${i} ${pc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = wc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${yc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${mc(l)}${i} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${r ? n + " " : ""}${t}`).join("\n");
    if (r) {
        const n = $c ? "" : `(${JSON.stringify(t).length} chars)`;
        $c = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const mc = t => Gu[t] || `Unknown(${t})`;

const wc = t => Yu[t] || `Unknown(${t})`;

function Dn(t, n, e, s = 0) {
    const o = Xn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Xn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const i = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let i = 1;
        let r = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            r = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = r + 1;
            const u = o;
            i = u[r];
            o = u[c];
            if (i === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                i = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[r] = 1;
            l[c] = n / 2;
        }
        t[n] = i;
        t[n + 1] = o;
    };
    for (let r = e; r < t.length; r += 2) {
        s(t[r], t[r + 1]) ? i(r) : o(t[r]) && (n.Pt = t[r + 1]);
        yield;
    }
}

const vc = new WeakMap;

const bc = new Map;

const _c = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.zt(e);
        return s === -1 || s === void 0 ? hr : t._(s);

      case 14:
        return e;

      case 3:
        return Ju[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const i = s.indexOf("#", o + 1);
                const r = +s.slice(0, o);
                const c = i === -1 ? +s.slice(o + 1) : +s.slice(o + 1, i);
                const l = r + c;
                const u = t._(r);
                const f = t._(l);
                n = jn(u, f, i !== -1 ? s : null, t);
            } else {
                n = jn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Ru(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return $a(null);

      case 30:
        return new qr(t, 0);

      case 31:
        return new Jr(t, null, null, null);

      case 32:
        return new Mr(t, null);

      case 33:
        return new Nr(t, null, void 0, {});

      case 34:
        return new Ir(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const i = _c(t, s, o);
            const r = Bu(i, 0, t);
            Gc(s) && bc.set(i, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = i;
            return r;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Gr(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let i;
        let r;
        const c = new Promise((t, n) => {
            i = t;
            r = n;
        });
        vc.set(c, [ i, r ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return m(null);

      case 10:
        return Wn(t, e);

      case 11:
        const h = Wn(t, e);
        if (pl(h)) {
            Gl(h);
            return mu(h);
        }
        throw Ye(17, [ typeof h ]);

      case 39:
        return new Yr({});

      case 42:
        return new Yr({
            O: null,
            et: !0
        });

      case 43:
        return new Yr({
            O: null,
            et: !1
        });

      case 40:
      case 44:
        return new Sr(null, null, null, null);

      case 41:
        return new Ku;

      default:
        throw Ye(18, [ n ]);
    }
};

function Wn(t, n) {
    return n ? t.rootVNode ? ql(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const gc = (t, n, e) => {
    let s = null;
    let o = null;
    if (Je(t)) {
        o = t;
    } else {
        if (!He(t)) {
            throw Ye(7, [ t ]);
        }
        s = t;
    }
    return ia(s, n, null, o, e);
};

const Ec = (t, n, e) => ia(null, n, t, null, e);

const Sc = (t, n) => ia(null, t, null, null, n);

const kc = (t, n, e) => {
    const s = Sc(t, e);
    return s;
};

const Rc = (t, n, e, s) => ia(t, e, null, n, s);

const Pc = (t, n, e, s, o) => {
    const i = Rc(t, n, e, o);
    i.je(s);
    return i;
};

const Tc = (t, n, e, s) => {
    const o = gc(t, n, s);
    return o;
};

const qc = (t, n, e, s) => {
    const o = Ec(t, n, s);
    return o;
};

const Ac = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Mc = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Vn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const xc = (t, n, e) => new Jr(null, t, n, e || null);

class Ic {
    Le;
    $t;
    Fe=null;
    Hn=!1;
    nn;
    _;
    ln;
    De=0;
    Bt=null;
    Xe=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.ln = t;
        this.nn = n;
        this.Le = Xs;
        this.$t = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return jf(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return ac(t, n, e, this.setHostProp.bind(this), this.$t, s);
    }
    dt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Nc = Symbol();

const ld = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Nc] = t;
    return n;
};

class Cc {}

function Un(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function zn(t, e, s) {
    const o = [ e ];
    const i = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === Cc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        Ji(n) && await n;
                    }
                    continue;
                }
                Bn(t, i, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                Ji(n) && await n;
            }
        }
    })();
}

function Bn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (qu(e)) {
            (function s(t, n) {
                const e = n instanceof Jr ? n.st() : n;
                if (e instanceof Mr) {
                    const n = e.Tt;
                    if (n && !(e.h & 256)) {
                        t.kt(e);
                        t.qt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(pr);
            const o = t.getOrCreateLastNode();
            const i = e instanceof Jr ? e.st() : e;
            n(t.closeFragment);
            n(() => jf(i, o, ".", t));
            n(Cc);
        } else if (Ji(e)) {
            t.openFragment(pr);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await zn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const i = o.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = wr(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let r = null;
                const c = t.openElement(i, o.key, o.varProps, o.constProps, s.currentStyleScoped, r, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.At) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = o.children;
                l != null && n(l);
            } else if (Je(i)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && Nc in t)(i)) {
                    n(() => (t => t[Nc])(i)(t, o, s, n));
                    return;
                }
                if (i === vo) {
                    const e = o.key != null ? {
                        [Ni]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (i === _o) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const i = e.componentNode.id || "";
                        const r = {};
                        const c = wr(o, Ri);
                        c && (r[Ri] = c);
                        r["q:sparent"] = i;
                        t.openProjection(r);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = k(l, o, t);
                        r[ui] = f;
                        n(Un(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(Un(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = pr;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === So) {
                    t.commentNode(wr(o, "data") || "");
                } else if (i === Ro) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let i;
                    i = Je(e) ? e({
                        async write(n) {
                            await zn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(i);
                    Ji(i) && n(Promise);
                } else if (i === Eo) {
                    t.htmlNode(wr(o, "data"));
                } else if (i === ko) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (ma(i)) {
                    const e = {};
                    t.openComponent(e);
                    const r = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[ya];
                        const i = n.props;
                        i && i.children && delete i.children;
                        s.setProp(ri, o);
                        s.setProp(Ci, i);
                        n.key !== null && s.setProp(Ni, n.key);
                        return Ko(t, s, s, o, i);
                    })(t, o, i);
                    n(Un(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (Ji(l)) {
                        n(async () => {
                            const t = await l;
                            const e = ns(r.getProp($i));
                            n(t);
                            n(Un(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = ns(r.getProp($i));
                        n(Un(s, t, c));
                    }
                } else {
                    const e = {
                        [Ni]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const r = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Ko(t, o, n, e, s.props);
                    })(t, s && s.componentNode, i, o);
                    n(r);
                    Ji(r) && n(Promise);
                }
            }
        }
    }
}

const Oc = () => Gf;

const jc = async t => {
    const [n, e] = Gf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Lc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e) {
        return e;
    }
    const i = ia(null, "_rsc", jc, null, [ t, {} ], o.$);
    const r = jr(i, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    r.p();
    const c = {
        __brand: "resource",
        signal: r,
        get value() {
            return r.promise().then(() => r.error ? Promise.reject(r.error) : r.value.r);
        },
        get loading() {
            return r.loading;
        }
    };
    s(c);
    return c;
};

const Fc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (Ji(t)) {
        return t.then(n, s);
    }
    const o = Dc(t);
    const i = o ? t.signal : t;
    if (e && i.loading) {
        return e();
    }
    if (s && i.error) {
        return s(i.error);
    }
    const r = o ? i.value?.r : i.value;
    return Ji(r) ? r.then(n, s) : n(r);
};

const Dc = t => t && t.__brand === "resource";

function Qn(t, n, e, s) {
    let o = null;
    const i = e;
    const r = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n._t.startsWith("_") || !Array.isArray(n.Mt) && !s || (n = ia(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = On(t, n, !0);
            const i = `${e}#${s}`;
            if (!o) {
                return i;
            }
            const r = [ i, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            r.push(" ");
                            r.push({
                                id: n,
                                base: c
                            });
                        } else {
                            r.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return r;
        }(t, n);
    };
    if (Array.isArray(i)) {
        for (let e = 0; e < i.length; e++) {
            const o = i[e];
            if (Ke(o)) {
                r(c(o));
                Hn(t, n, o);
            } else if (o != null) {
                const e = Qn(t, n, o, s);
                e && r(e);
            }
        }
    } else if (Ke(i)) {
        o = c(i);
        Hn(t, n, i);
    }
    return o;
}

function Hn(t, n, e) {
    const s = rs(n);
    if (s) {
        const [n, o] = s;
        const i = ((t, n) => t + ":" + n)(n, o);
        t.xt.add(i);
        t.It.add(e);
    }
}

const Xc = (t, n, e) => {
    Uc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Wc = (t, n, e) => {
    Uc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Vc = (t, n, e) => {
    Uc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Uc = (t, n, e, s) => {
    const {isAdded: o, addEvent: i} = zc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const r = n[o];
                i(t + ss(r), e, s);
            }
        } else {
            i(t + ss(n), e, s);
        }
    }
};

const zc = () => {
    const t = xf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Xi);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Xi, s);
    }
    let o = t.$.getHostProp(e, Wi);
    o === null && (o = 0);
    t.$.setHostProp(e, Wi, o + 1);
    let i = t.$.getHostProp(e, Vi);
    if (i === null) {
        i = [];
        t.$.setHostProp(e, Vi, i);
    }
    for (;i.length <= o; ) {
        i.push(!1);
    }
    return {
        isAdded: i[o],
        addEvent: (t, n, e) => {
            i[o] = !0;
            let r = s[t];
            r || (s[t] = r = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            r.qrls.push(n);
            e?.capture && (r.capture = !0);
            e?.preventdefault && (r.preventdefault = !0);
            e?.stoppropagation && (r.stoppropagation = !0);
        }
    };
};

const Bc = function(t, n) {
    const e = Ee(n);
    return Rf(e, () => {
        typeof this === "string" && Kf(Zf(e, this));
        const s = Gf?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const i = Gf?.[0];
        if (!i || i.flags & 32) {
            return;
        }
        yn(e, i, 4);
        const r = n.ownerDocument;
        r.__hmrDone = r.__hmrT;
    });
};

let Qc;

function Jn(t) {
    const n = Af();
    if (!n) {
        return;
    }
    Qc ||= Ec(Bc, "_hmr");
    const e = n.m;
    const s = Qc.w([ e, t ]);
    Wc("qHmr", s);
}

function Yn(t, n, e, s, o) {
    const i = dl();
    gl(i, ui, o);
    i.parent = n;
    gl(n, o, i);
    gl(i, ri, e);
    gl(i, Ci, s);
    i.dirty = 4;
    hn(t, i, 1);
    return i;
}

function Gn(t, n) {
    gl(t, oi, n);
    t.flags |= 2048;
}

function Kn(t, n, e) {
    gl(n, Ci, e);
    yn(t, n, 4);
}

function Zn(t, n, e, s) {
    gl(n, s, null);
    const o = [];
    Et(t, o, e);
    Cl(o);
    if (e.flags & 2048) {
        const t = _l(e, oi, null);
        t && t.replaceChildren();
        gl(e, oi, null);
        e.flags &= -2049;
    }
}

let Hc = Promise.resolve();

const Jc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Yc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Jc.has(t));
};

function* te(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ee(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ne(t, n, e = Array(n.length / 2)) {
    const s = n.length / 2;
    const o = new Uint8Array(s);
    const i = t._;
    const r = s => {
        if (!o[s]) {
            o[s] = 1;
            const i = s * 2;
            const r = n[i];
            const c = n[i + 1];
            e[s] = r === 0 ? c : _c(t, r, c);
        }
        return e[s];
    };
    t._ = t => r(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < s; t++) {
            r(t);
            yield;
        }
        for (let o = 0; o < s; o++) {
            const s = o * 2;
            const i = n[s];
            const r = n[s + 1];
            const c = e[o];
            n[s] = 0;
            n[s + 1] = c;
            Gc(i) && (yield* ie(t, c, i, r));
            yield;
        }
    } finally {
        t._ = i;
    }
    return e;
}

function* ee(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = _c(t, n, e);
    Gc(n) && (yield* ie(t, s, n, e));
    return s;
}

function* ie(t, n, e, s) {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = yield* te(t, s));
    switch (e) {
      case 4:
        yield* te(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Yc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [i, r] = vc.get(t);
            e ? i(o) : r(o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t.bt = e[0];
            t.h = e[1];
            t.Nt = e[2];
            t.ht = e[3];
            break;
        }

      case 29:
        n[ya][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Ct = e[0];
            t.ft = new Set(e.slice(1));
            re(t.ft, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.lt = t.getSyncFn(o[0]);
            e.ut = o[1];
            e.Ct = Er;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ft = new Set(o.slice(4));
            (function i(t) {
                if (t.m !== null && pl(t.m)) {
                    const n = t.m;
                    const e = t.ft;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (He(e)) {
                                const o = _l(n, e, null);
                                if (o !== null) {
                                    t.Ct = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Yl(n);
                        e && n.firstChild === n.lastChild && wl(e) && (t.Ct = Hl(e));
                    }
                }
            })(e);
            re(e.ft, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Ot = e[0];
            e[1] && (t.ft = new Set(e[1]));
            e[2] && (t.yt = new Set(e[2]));
            e[3] && (t.wt = new Set(e[3]));
            e[4] && (t.jt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Lt = !0);
            const o = e.length > 6;
            o && (t.Ct = e[6]);
            t.Ct === Er && (t.h |= 1);
            const i = e[7] ?? 0;
            t.expires = Math.abs(i);
            i < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.Ft = e[8] ?? 1;
                t.Dt = [];
            }
            t.Xt = e[9] ?? 0;
            re(t.ft, t);
            re(t.yt, t);
            re(t.wt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const i = s;
            o.Ot = i[0];
            const r = o.Ot.resolve(t).catch(() => {});
            Hc = Hc.finally(() => r);
            i[1] && (o.ft = new Set(i[1]));
            const c = i.length > 2;
            c && (o.Ct = i[2]);
            e !== 34 && o.Ct !== Er && (o.h &= -2);
            re(o.ft, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, i, r, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = i;
            t.constProps = r || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === hr) {
                o = new Gr(vo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[cr] = o;
            const i = t[fr];
            i.ft = e[3];
            oe(i.ft, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            se(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            se(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Uu(n);
            const o = bc.get(e);
            if (o) {
                bc.delete(e);
                yield* ie(t, e, o.t, o.v);
            }
            const [, i, r] = s;
            const c = Du(n);
            c.h = i;
            c.ft = r;
            oe(c.ft, e);
            break;
        }

      default:
        throw Ye(16, [ e ]);
    }
}

function se(t) {
    const n = Ce;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[Vs] ||= new Map;
    e[Vs].set(t.property, t);
}

function re(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function oe(t, n) {
    if (t) {
        for (const [, e] of t) {
            re(e, n);
        }
    }
}

const Gc = t => t >= 23 || t === 4 || t === 5;

const Kc = new WeakMap;

const Zc = Symbol();

const tf = (t, n) => {
    if (!Array.isArray(n) || pl(n) || (t => Be(t) && Zc in t)(n)) {
        return n;
    }
    let e = Kc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new nf(t, n));
        Kc.set(n, e);
    }
    return e;
};

class nf {
    $;
    We;
    constructor(t, n) {
        this.$ = t;
        this.We = n;
    }
    get(t, n, e) {
        if (n === Zc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.We.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const i = this.We[o];
        const r = this.We[o + 1];
        if (i === 0) {
            return r;
        }
        const c = this.$;
        const l = _c(c, i, r);
        Reflect.set(t, n, l);
        this.We[o] = 0;
        this.We[o + 1] = l;
        Gc(i) && ((t, n, e, s) => {
            const o = ie(t, n, e, s);
            for (;!o.next().done; ) {}
        })(c, l, i, r);
        return l;
    }
    has(t, n) {
        if (n === Zc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === Zc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const i = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(i) || i < 0 || i >= this.We.length / 2) {
            return o;
        }
        const r = i * 2;
        this.We[r] = 0;
        this.We[r + 1] = e;
        return !0;
    }
}

const ef = t => {
    if (!t.Ve) {
        t.Ve = !0;
        t.Ue();
    }
};

const sf = (t, n, e) => {
    const s = {
        ze: t,
        Ue: void 0,
        Ve: !1
    };
    const o = hs(() => {
        ((t, n, e) => {
            t.Ve = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.ze.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        ef(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.un?.();
            n(t);
        }, t => {
            o.un?.();
            e(t);
        });
    });
    s.Ue = o;
    return s;
};

async function le(t) {
    const n = ac(null, null, () => "", () => {}, new WeakMap);
    n.kt(t);
    await n.Wt();
    return n.Vt.toString();
}

async function ue(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = ae(n, () => e);
    s.Ut = e;
    await rf(ne(s, n, e));
    return e[0];
}

const rf = t => new Promise((n, e) => {
    const s = sf(t, n, e);
    ef(s);
});

function ce(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function fe(t) {
    let n;
    const e = ae(t, () => n);
    n = tf(e, t);
    e.Ut = n;
    return e;
}

function ae(t, n) {
    const e = {
        _: t => ce(t, n()),
        zt: t => e.Pt?.[+t],
        getSyncFn: () => () => {},
        $t: new WeakMap,
        element: null,
        Pt: null
    };
    Dn(t, e);
    return e;
}

const of = (t, n) => {
    const e = new WeakSet;
    return Nf(lf, t, e, "_", n);
};

const lf = (t, n, e, s) => {
    const o = Uu(t);
    if (o == null) {
        return t;
    }
    if (cf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (qu(o)) {
            return t;
        }
        if (dc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const i = typeof o;
        switch (i) {
          case "object":
            if (Ji(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Qe(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Ye(3, [ o ]);
                    }
                    const i = o[t];
                    if (t !== s) {
                        throw Ye(3, [ o ]);
                    }
                    lf(i, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Js) {
                return t;
            }
            if (ze(o)) {
                for (const [t, s] of Object.entries(o)) {
                    lf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let r;
        r = s || "Value cannot be serialized";
        e !== "_" && (r += ` in ${e},`);
        if (i === "object") {
            r += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (i === "function") {
            const n = t.name;
            r += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Ye(3, [ r ]);
    }
    return t;
};

const uf = /*#__PURE__*/ new WeakSet;

const cf = t => {
    if (Be(t) || Je(t)) {
        return !uf.has(t) && !(hf in t);
    }
    return !0;
};

const ff = t => !!t && (Be(t) || typeof t === "function") && (uf.has(t) || hf in t);

const af = t => {
    (Be(t) && t !== null || typeof t === "function") && uf.add(t);
    return t;
};

const hf = Symbol();

const df = Symbol();

const pf = t => /*#__PURE__*/ Object.freeze({
    id: ss(t)
});

const $f = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const yf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e !== void 0) {
        return e;
    }
    const i = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(qe(void 0, n, i));
    }
    if (i !== void 0) {
        return s(i);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Ye(8, [ t.id ]);
};

const mf = t => {
    const n = Mf();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const wf = /*#__PURE__*/ pf("qk-error");

const ud = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const fd = new WeakMap;

class ad {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = hd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return ud(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const hd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const dd = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = Af()?.$;
    return t?.outOfOrderStreaming === !0 && !rd(t);
};

const vf = (t, n, e, s, o) => {
    let i;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (i ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    i && Nu(t, n, i);
};

const bf = new WeakMap;

function* he(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Bt}"]${fi}`);
    const o = _f(t);
    for (let i = 0; i < s.length; i++) {
        const r = s[i];
        if (n !== void 0 && r.getAttribute(ai) !== n) {
            continue;
        }
        if (o.has(r)) {
            continue;
        }
        o.add(r);
        yield* de(t, e, r.textContent);
        yield;
    }
}

const _f = t => {
    let n = bf.get(t);
    if (!n) {
        n = new WeakSet;
        bf.set(t, n);
    }
    return n;
};

function* de(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, i, r] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.Qt.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.Qt[e * 2 + t] = s[t];
            yield;
        }
        yield* Xn(n.Qt, t, e * 2);
        n.Ht = tf(t, n.Qt);
        n.Ht.length = n.Qt.length / 2;
        n.Jt = n.Pt;
    }(t, n, s, o);
    gf(n, i || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t._(s.rootId);
            const i = s.subscriptions;
            if (o instanceof qr) {
                i instanceof Set && vf(t, o, o, o.ft ||= new Set, i);
            } else {
                if (!(i instanceof Map)) {
                    continue;
                }
                const n = Du(o);
                const e = Xu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ft ||= new Map;
                for (const [o, r] of i) {
                    let i = s.get(o);
                    if (!i) {
                        i = new Set;
                        s.set(o, i);
                    }
                    vf(t, n, e, i, r);
                }
            }
        }
    })(t, r === void 0 ? void 0 : n._(r));
}

const gf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Jt ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Pt = e;
};

const Ef = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function pe(t, n) {
    const e = t.qVNodeDataState ||= {
        Yt: [],
        Gt: null
    };
    t.qProcessVNodeDataPatch ||= n => pe(t, me(t, n));
    t.qVNodeDataReady = !1;
    e.Yt.push(n);
    $e(t, e);
}

function $e(t, n) {
    if (n.Gt) {
        return;
    }
    const e = n.Yt.shift();
    if (!e) {
        ye(t);
        return;
    }
    n.Gt = sf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.Gt = null;
            $e(t, n);
        }
    }, e => {
        n.Gt = null;
        Fe(e);
        ye(t);
    });
    ef(n.Gt);
}

function ye(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* me(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* we(t, s || void 0, e, o, n.textContent));
}

function* we(t, n, e, s, o) {
    const i = "q:container";
    const r = "/" + i;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const m = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const w = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const i = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            i ? (s.qSegmentVnodeData ||= new Map).set(i, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* w(s));
            yield;
        }
    };
    const b = t => {
        const n = m.call(t);
        if (n === 1) {
            if ($.call(t, i) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(i)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(r)) {
                return 8;
            }
        }
        return 0;
    };
    const v = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const _ = function*(n, e, s, o, i, r, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = i.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let m = 0;
        let w = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;Sf(w = i.charCodeAt(y)); ) {
                t += 1 << w - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = v(e)); ) {
                    e = e.parentNode;
                }
                yield* _(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = v(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                yield* _(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = v(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* _(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = m;
                    if (y < f) {
                        p += k();
                        if (w === 126) {
                            g = p;
                            y++;
                            w = y < f ? i.charCodeAt(m) : 33;
                        }
                        m = kf(i, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || r.set(u ? si(l, h) : h, s);
                    const t = i.substring(y, m);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== ii || n.charCodeAt(1) !== ii || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* E(c, s, t);
                    S = v(s);
                    S && (n.currentNode = S);
                }
            }
            yield;
        } while (s = S || n.nextNode());
    };
    const g = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const i = t.createTreeWalker(t, 129);
        i.currentNode = e;
        yield* _(i, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const E = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* g(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* E(e, s, n, o) : yield* g(e, s, o);
        return;
    }
    yield* w(t);
    const S = t.createTreeWalker(t, 129);
    yield* _(S, null, S.firstChild(), null, "", null, null);
}

const Sf = t => 33 <= t && t <= 46;

const kf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Sf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function ve(t) {
    return t.Kt === 3;
}

function be(t, n) {
    const e = t.Zt ||= {
        Yt: [],
        Gt: null
    };
    t.Kt = 2;
    e.Yt.push(n);
    _e(t, e);
}

const Rf = (t, n) => {
    const e = t;
    if (ve(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!ve(e)) {
                    (e.tn ||= []).push(s);
                    return;
                }
                Ef(e.document, () => {
                    ve(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function _e(t, n) {
    if (n.Gt) {
        return;
    }
    const e = n.Yt.shift();
    if (!e) {
        ge(t);
        return;
    }
    n.Gt = sf(e, () => {
        n.Gt = null;
        _e(t, n);
    }, e => {
        n.Gt = null;
        Fe(e);
        ge(t);
    });
    ef(n.Gt);
}

function ge(t) {
    const n = t.Kt;
    if (n !== 2) {
        return;
    }
    t.Kt = 3;
    t.Zt = void 0;
    const e = t.tn;
    t.tn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Ee(t) {
    const n = ke(t);
    if (!n) {
        throw Ye(24);
    }
    return Se(n);
}

function Se(t) {
    const n = t;
    return n.qContainer ||= new Pf(n);
}

function ke(t) {
    return t.closest(Ti);
}

function Re(t, n) {
    const e = t + "";
    const s = n?.closest(Ti);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const i = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            pe(t, function* r(t, n, e, s, o, i) {
                yield* we(t, n, e, s, o);
                for (let n = 0; n < i.length; n++) {
                    yield* me(t, i[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, i));
        })(t, e, n);
        Ef(t, () => {
            o.element.qContainer === o && be(o, he(o, e));
        });
    }
}

class Pf extends Ic {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    $t=new WeakMap;
    Be;
    Bt;
    Pt=null;
    vNodeLocate=t => ql(this.rootVNode, t);
    Kt=0;
    tn=void 0;
    Zt=void 0;
    Qt;
    Ht;
    Jt=null;
    Qe=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Si);
        if (!this.qContainer) {
            throw Ye(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.Xe = t.getAttribute(vi);
        this.Bt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = al(this.element);
        this.Qt = [];
        this.Ht = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= Re);
        this.Be = wi(n, this.Bt) || dr;
        this.He();
        t.qContainer = this;
        t.qDestroy = () => this.un();
        this.Kt = 1;
        (function e(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            pe(e, function* s(t) {
                yield* we(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Ef(n, () => {
            this.Kt === 1 && be(this, this.Je());
        });
    }
    * Je() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Bt}"]:not(${fi})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${fi})`);
        if (n) {
            this.Qt = JSON.parse(n.textContent);
            yield* Xn(this.Qt, this);
            this.Jt = this.Pt;
            const e = this.Qt.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.Ht = s !== null && e > 0 && e >= +s ? yield* ne(this, this.Qt) : tf(this, this.Qt);
        }
        __EXPERIMENTAL__.suspense && (yield* he(this));
        this.Ye();
        t.setAttribute(Si, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    un() {
        this.vNodeLocate = () => null;
        this.Qt.length = 0;
        this.Ht.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Si);
        const n = t.ownerDocument;
        this.Zt = void 0;
        this.Kt = 0;
        const e = n.querySelector(Ti) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    Ye() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(pi);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    zn(t, n) {
        this.Ht[t] = n;
    }
    parseQRL(t) {
        const n = Ln(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, wf);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, yi);
        s == null && this.setHostProp(t, yi, s = []);
        We(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, yi);
            if (e != null && Ue(e, n.id, 0)) {
                return Ve(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (vl(n)) {
                if (_l(n, ri, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        gl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Oi:
          case Ci:
          case ri:
          case yi:
          case mi:
          case Ri:
            s = this._;
            break;

          case ji:
          case Wi:
            s = parseInt;
            break;
        }
        return _l(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => ce(t, this.Ht);
    zt(t) {
        return this.Jt?.[t];
    }
    getSyncFn(t) {
        const n = this.Be[t];
        return n;
    }
    Ge(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, $i);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, $i, function i(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Qe == null) {
            this.Qe = new Set;
            const t = this.document.querySelectorAll(di);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Qe.add(e.getAttribute(hi));
            }
        }
        if (!this.Qe.has(n)) {
            this.Qe.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(hi, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    He() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === zi) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.ln = {
            containerAttributes: t
        };
    }
}

let Tf;

let pd;

if (Ce) {
    const t = Mc();
    t && (pd = new t);
}

function Pe(t) {
    if (pd) {
        const t = pd.getStore();
        if (t) {
            return t;
        }
    }
    if (Tf === void 0) {
        const n = Af();
        if (n && n.nn) {
            return n.nn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Tf;
}

function Te(t, n) {
    if (pd) {
        return pd.run(t, n);
    }
    const e = Tf;
    try {
        Tf = t;
        return n();
    } finally {
        Tf = e;
    }
}

let qf;

const Af = () => qf;

const Mf = () => {
    const t = Af();
    if (!t) {
        throw Ye(9);
    }
    return t;
};

const xf = () => {
    const t = Af();
    if (!t || t.en !== xi) {
        throw Ye(10);
    }
    return t;
};

function qe(t, n, ...e) {
    return Ae.call(this, t, n, e);
}

function Ae(t, n, e) {
    const s = qf;
    try {
        qf = t;
        return n.apply(this, e);
    } finally {
        qf = s;
    }
}

const If = (t, n, e = Ee(n)) => {
    const s = ql(e.rootVNode, n);
    const o = e.nn;
    o && function i(t) {
        if (pd) {
            pd.enterWith(t);
            return;
        }
        Tf = t;
    }(o);
    const r = xe(o, s, t);
    r.$ = e;
    return r;
};

function Me(t, n, e) {
    const s = {
        m: n,
        en: xi,
        sn: void 0,
        nn: t,
        $: e,
        rn: void 0
    };
    return s;
}

function xe(t, n, e) {
    const s = t || (e && Be(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        en: e,
        sn: void 0,
        nn: s,
        $: void 0
    };
    return o;
}

const Nf = (t, ...n) => {
    if (typeof t === "function") {
        if (!qf) {
            return t(...n);
        }
        {
            const e = qf.sn;
            try {
                qf.sn = void 0;
                return t(...n);
            } finally {
                qf.sn = e;
            }
        }
    }
    if (qu(t)) {
        return t.untrackedValue;
    }
    return Uu(t);
};

const Cf = /*#__PURE__*/ Me(void 0, void 0, void 0);

const Of = (t, n, e, s, o) => {
    const i = Cf.sn;
    const r = Cf.$;
    try {
        Cf.sn = w(n, e, o);
        Cf.$ = s;
        return Ae(Cf, t);
    } finally {
        Cf.sn = i;
        Cf.$ = r;
    }
};

const jf = (t, n, e, s, o) => {
    t instanceof Jr && t.m !== n && n && (t.m = n);
    return Of(() => t.value, n, e, s, o);
};

const Lf = () => Af()?.m;

const Ff = () => {
    const t = Af();
    if (t) {
        return t.en;
    }
};

const Df = () => {
    const t = Af();
    if (t) {
        return t.$;
    }
};

const Xf = t => t;

const Wf = t => t.l || Promise.resolve();

let Vf = (t, n, e, s, o) => new Uf(t, n, e, s, o);

class Uf {
    gt;
    _t;
    Ke;
    Ze;
    $;
    constructor(t, n, e, s, o) {
        this.gt = t;
        this._t = n;
        this.Ke = e;
        this.Ze = s;
        s && this.ti(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        Oe && t && Ne(t, .8);
    }
    get rt() {
        return nd(this._t);
    }
    ti(t) {
        this.Ze = t;
        Ji(t) && t.then(t => this.Ze = t, t => {
            console.error(`qrl ${this._t} failed to load`, t);
            this.Ze = null;
        });
    }
    ni() {
        if (this.Ze != null) {
            return this.Ze;
        }
        if (this.gt === "") {
            const t = this.$.Bt;
            const n = this.$.element?.ownerDocument || document;
            const e = wi(n, t);
            return this.Ze = e[+this._t];
        }
        Oe && this.gt && Ne(this.gt, 1);
        const t = this._t;
        const n = this.Ke ? this.Ke().then(n => n[t]) : ms().importSymbol(this.$?.element, this.gt, t);
        this.ti(n);
        return this.Ze;
    }
}

Oe && import.meta.hot && (t => {
    if (!Oe || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Vf = (e, s, o, i, r) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, i, r);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let i = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.gt;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const r = t.gt;
            if (r) {
                t.gt = e(r, o);
                i = !0;
            }
            const c = t.Ke?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const i = e(s, o);
                    return `import(${n}${i}${n})`;
                });
                if (n !== c) {
                    try {
                        t.Ke = Function(`return (${n})`)();
                        i = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t._t, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t._t}, cannot update it for HMR`, c);
                }
            }
            if (i) {
                t.Ze = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(Uf);

const zf = Symbol();

const Bf = t => t?.[zf] ?? t;

class Qf {
    ei;
    resolved=void 0;
    Mt;
    $;
    constructor(t, n, e) {
        this.ei = t;
        if (n) {
            this.Mt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.Ze == null || this.Mt && typeof this.Mt === "string" || Ji(t.Ze) || (this.resolved = na(this, t.Ze));
    }
}

const Hf = function(t, ...n) {
    const e = Bf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = Af();
    return Jf.call(e, s?.$).then(() => Ae.call(t, s, e.resolved, n));
};

const Jf = async function(t) {
    const n = Bf(this);
    return Gi(ea(n, t), () => n.resolved);
};

const Yf = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[zf].resolved;
        },
        set(t) {
            this[zf].resolved = t;
        }
    },
    Mt: {
        get() {
            return this[zf].Mt;
        },
        set(t) {
            this[zf].Mt = t;
        }
    },
    $: {
        get() {
            return this[zf].$;
        },
        set(t) {
            this[zf].$ = t;
        }
    },
    ei: {
        get() {
            return this[zf].ei;
        }
    },
    gt: {
        get() {
            return this[zf].ei.gt;
        }
    },
    _t: {
        get() {
            return this[zf].ei._t;
        }
    },
    rt: {
        get() {
            return this[zf].ei.rt;
        }
    },
    dev: {
        get() {
            return this[zf].ei.dev;
        }
    },
    ii: {
        value: Hf
    },
    w: {
        value: function(t) {
            const n = Bf(this);
            const e = new Qf(n.ei, t, n.Mt ? n.$ : void 0);
            return sa(e);
        }
    },
    s: {
        value: function(t) {
            const n = Bf(this);
            n.ei.ti(t);
            n.resolved = na(n, t);
        }
    },
    resolve: {
        value: Jf
    },
    getSymbol: {
        value: function() {
            return Bf(this).ei._t;
        }
    },
    getHash: {
        value: function() {
            return Bf(this).ei.rt;
        }
    },
    getCaptured: {
        value: function() {
            const t = Bf(this);
            ta(t);
            return t.Mt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Bf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Jf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Ae(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Gf = null;

const Kf = t => {
    Gf = t;
};

const Zf = (t, n, e = 0, s) => {
    const o = [];
    let i = s;
    let r = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > r) {
                const e = +n.slice(r, s);
                i = i === void 0 ? e : i + e;
                o.push(t._(i));
            }
            r = s + 1;
        }
    }
    return o;
};

const ta = t => {
    const n = t.Mt;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw Ye(13);
        }
        const s = Hc;
        Gf = t.Mt = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return Zf(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return Zf(t, n, s + 1, o);
        })(e, n);
        if (Hc !== s) {
            return Hc;
        }
    } else {
        Gf = n || null;
    }
};

const na = (t, n) => {
    if (typeof n !== "function" || !t.Mt) {
        return n;
    }
    return function e(...s) {
        ta(t);
        return n.apply(this, s);
    };
};

const ea = (t, n) => {
    const e = t.ei;
    const s = typeof t.Mt === "string";
    s && !t.$ && (t.$ = n || Af()?.$);
    if (t.resolved) {
        return;
    }
    const o = ua();
    const i = Af();
    const r = e.ni();
    const c = Gi(r, n => {
        t.resolved = na(t, n);
    });
    if (c) {
        const t = e._t;
        oa(t, i?.m instanceof Gs ? i?.m.node : void 0, o);
    }
    const l = s && t.$ && ta(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const ia = (t, n, e, s, o, i) => {
    const r = Vf(t, n, s, e, i);
    const c = new Qf(r, o, i);
    return sa(c);
};

const sa = t => {
    const n = async function(...t) {
        return Hf.call(n, this, ...t);
    };
    n[zf] = t;
    Object.setPrototypeOf(n, Yf);
    return n;
};

const ra = /*#__PURE__*/ new Set;

const oa = (t, n, e) => {
    if (!ra.has(t)) {
        ra.add(t);
        la("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const la = (t, n) => {
    sd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const ua = () => {
    if (sd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let ca = 0;

const fa = t => ia(null, "s" + ca++, t, null, null);

const aa = fa;

const ha = t => t;

const da = t => ia("", Ge, t, null, null);

const pa = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return ia("", Ge, t, null, null);
};

const $a = t => {
    function n(n, e, s = 0) {
        const o = t.rt.slice(0, 4);
        const i = o + ":" + (e || "");
        const r = () => {};
        r[ya] = [ t ];
        return fo(r, n, null, n.children, s, i);
    }
    n[ya] = [ t ];
    return n;
};

const ya = Symbol();

const ma = t => typeof t == "function" && t[ya] !== void 0;

const wa = t => $a(aa(t));

const va = xr(ha);

const ba = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const _a = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Ws(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Si, "resumed");
    const s = Ee(t);
    s.ln = e.serverData || {};
    const o = s.rootVNode;
    gl(o, ir, n);
    yn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const ga = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e != null) {
        return e;
    }
    const i = Je(t) ? qe(void 0, t) : t;
    if (n?.reactive === !1) {
        s(i);
        return i;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const r = e ? 1 : 0;
        const c = Bu(i, r, t);
        s(c);
        return c;
    }
};

const Ea = () => {
    const {val: t, set: n, iCtx: e} = Wo();
    if (t != null) {
        return t;
    }
    const s = e.$.Xe || "";
    const o = s ? ls(s).substring(0, 3) : "";
    const i = e.$.getHostProp(e.m, ri);
    const r = i?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.Fe;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.De++);
    })(e.$) || "";
    let l = `${o}${r}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Ie(t, n) {
    const e = Af();
    return e?.$?.ln[t] ?? n;
}

const Sa = /*#__PURE__*/ new Map;

const ka = (t, n) => {
    let e = Sa.get(n);
    e || Sa.set(n, e = Ra(t, n));
    return e;
};

const Ra = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let i = 0;
    let r = i;
    let c = Ma;
    let l = 0;
    for (;i < e; ) {
        const n = i;
        let e = t.charCodeAt(i++);
        if (e === sh) {
            i++;
            e = nh;
        }
        const s = hh[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === Da || $ === Xa && Pa(l) || $ === Va && Aa(l)) && (y === e || y === Da || y === Xa && Pa(e) || y === Wa && !Pa(e) && e !== Ga || y === Va && Aa(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(i - 1));
                if (m === La || m == Fa) {
                    if (m === Fa) {
                        if (c !== xa || h()) {
                            if (!Ta(e)) {
                                const t = y == Wa ? 1 : y == Ja ? 2 : 0;
                                f(i - t);
                            }
                        } else {
                            Ta(e) ? u(i - 2) : f(i - 2);
                            r++;
                        }
                    }
                    if (y === Wa) {
                        i--;
                        e = l;
                    }
                    do {
                        c = o.pop() || Ma;
                        if (c === Ia) {
                            u(i - 1);
                            r++;
                        }
                    } while (qa(c));
                } else {
                    o.push(c);
                    if (c === Ia && m === Ma) {
                        u(i - 8);
                        r = i;
                    } else {
                        m === Na && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(i);
    return s.join("");
    function u(n) {
        s.push(t.substring(r, n));
        r = n;
    }
    function f(t) {
        if (c === Ia || h()) {
            return;
        }
        u(t);
        s.push(".", li, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(i) === Ya) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(i + n) === Ya) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(i + n + e) | oh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            i += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(Ia) !== -1 || o.indexOf(Ca) !== -1;
    }
};

const Pa = t => t >= Ka && t <= Za || t >= nh && t <= eh || t >= lh && t <= uh || t >= 128 || t === rh || t === Ya;

const Ta = t => t === th || t === Ga || t === ih || t === Ha || Pa(t);

const qa = t => t === Oa || t === Ca || t === ja || t === Ia;

const Aa = t => t === Qa || t === Ua || t === za || t === Ba;

const Ma = 0;

const xa = 2;

const Ia = 5;

const Na = 6;

const Ca = 10;

const Oa = 11;

const ja = 12;

const La = 17;

const Fa = 18;

const Da = 0;

const Xa = 1;

const Wa = 2;

const Va = 3;

const Ua = 9;

const za = 10;

const Ba = 13;

const Qa = 32;

const Ha = 35;

const Ja = 41;

const Ya = 45;

const Ga = 46;

const Ka = 48;

const Za = 57;

const th = 58;

const nh = 65;

const eh = 90;

const ih = 91;

const sh = 92;

const rh = 95;

const oh = 32;

const lh = 97;

const uh = 122;

const ch = 123;

const fh = 125;

const ah = /*@__PURE__*/ (() => [ [ Da, 39, 14 ], [ Da, 34, 15 ], [ Da, 47, 16, "*" ] ])();

const hh = /*@__PURE__*/ (() => [ [ [ Da, 42, xa ], [ Da, ih, 7 ], [ Da, th, Na, ":", "before", "after", "first-letter", "first-line" ], [ Da, th, Ia, "global" ], [ Da, th, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ Da, th, 4 ], [ Da, Xa, 1 ], [ Da, Ga, 1 ], [ Da, Ha, 1 ], [ Da, 64, Ca, "keyframe" ], [ Da, 64, Oa, "media", "supports", "container" ], [ Da, 64, ja ], [ Da, ch, 13 ], [ 47, 42, 16 ], [ Da, 59, La ], [ Da, fh, La ], [ Da, Ja, La ], ...ah ], [ [ Da, Wa, Fa ] ], [ [ Da, Wa, Fa ] ], [ [ Da, 40, Ma ], [ Da, Wa, Fa ] ], [ [ Da, 40, 8 ], [ Da, Wa, Fa ] ], [ [ Da, 40, Ma ], [ Da, Wa, La ] ], [ [ Da, Wa, La ] ], [ [ Da, 93, Fa ], [ Da, 39, 14 ], [ Da, 34, 15 ] ], [ [ Da, Ja, La ], ...ah ], [ [ Da, fh, La ], ...ah ], [ [ Da, fh, La ], [ Va, Xa, 1 ], [ Da, th, Ia, "global" ], [ Da, ch, 13 ], ...ah ], [ [ Da, ch, Ma ], [ Da, 59, La ], ...ah ], [ [ Da, 59, La ], [ Da, ch, 9 ], ...ah ], [ [ Da, fh, La ], [ Da, ch, 13 ], [ Da, 40, 8 ], ...ah ], [ [ Da, 39, La ] ], [ [ Da, 34, La ] ], [ [ 42, 47, La ] ] ])();

const dh = t => ({
    styleId: mh(t, t => t, !1)
});

const ph = /*#__PURE__*/ xr(dh);

const $h = t => ({
    scopeId: li + mh(t, ka, !0)
});

const yh = /*#__PURE__*/ xr($h);

const mh = (t, n, e) => {
    let {val: s, set: o, iCtx: i, i: r} = Wo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${ls(t.rt)}-${n}`)(t, r);
    const l = i.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => i.$.Ge(n(t, c), c, l, e));
    }
    i.$.Ge(n(t.resolved, c), c, l, e);
    return c;
};

const wh = (t, n) => {
    t.resolve();
    return Or(t, n);
};

const vh = (t, n) => zo(wh, t, n);

const bh = xr(vh);

const _h = t => {
    t.resolve();
    return Lr(t);
};

const gh = t => zo(_h, t);

const Eh = xr(gh);

const Sh = (t, n) => {
    const {val: e, set: s, i: o, iCtx: i} = Wo();
    const r = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !sd()) {
            e.h |= 32;
            kh(e, r);
        }
        return;
    }
    let c;
    if (sd()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        yn(i.$, i.m, 1);
    }
    const l = new Ru(c, o, i.m, t, null);
    s(l);
    kh(l, r);
};

const kh = (t, n) => {
    n === "intersection-observer" ? Xc("qvisible", Rh(t)) : n === "document-ready" ? Wc("qinit", Rh(t)) : n === "document-idle" && Wc("qidle", Rh(t));
};

const Rh = t => ia(null, "_task", An, null, [ t ]);

const Ph = xr(Lc);

const Th = /*#__PURE__*/ xr(Su);

const qh = /*#__PURE__*/ xr(Sh);

const Ah = (t, n) => {
    t.resolve();
    return jr(t, n);
};

const Mh = (t, n) => zo(Ah, t, n);

const xh = xr(Mh);

const Ih = () => {
    const t = ga({
        error: void 0
    });
    $f(wf, t);
    return t;
};

const Nh = async ({track: t}) => {
    const n = Gf[0];
    t(() => n.items);
    const e = Af();
    const s = e.m;
    const o = e.$;
    yn(o, s, 256);
    const i = Ce;
    i && await o.l;
};

const Ch = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Su(/*#__PURE__*/ Ec(Nh, "_eaT", [ t ]));
    return go;
};

const Oh = /*#__PURE__*/ $a(
/*#__PURE__*/ Ec(Ch, "_eaC"));

const jh = (t, n, e) => Ke(t) ? t.getFn(n)(e) : t(e);

const Lh = ({track: t}) => {
    const n = Gf[0];
    const e = Af();
    const s = e.m;
    const o = e.$;
    const i = Ce;
    return Gi(t(() => jh(n.when$, Af(), void 0)), t => {
        const r = t ? n.then$ : n.else$;
        return Gi(r ? jh(r, e, t) : null, t => {
            const n = r ? [ t ] : [];
            if (i) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Ut(s, n);
            yn(o, s, 2);
        });
    });
};

const Fh = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Su(/*#__PURE__*/ Ec(Lh, "_shT", [ t ]));
    return go;
};

const Dh = /*#__PURE__*/ $a(
/*#__PURE__*/ Ec(Fh, "_shC"));

const Xh = /*#__PURE__*/ pf("qk-reveal");

const Wh = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Fr(0)
});

const Vh = () => {
    const t = Gf[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Oe) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return ud(t);
};

const Uh = ({cleanup: t}) => {
    const n = Gf[0];
    t(() => {
        if (!Oe) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const zh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = zo(Wh, t);
    $f(Xh, n);
    const e = !Oe;
    if (__EXPERIMENTAL__.suspense && e && dd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!dd()) {
                    return null;
                }
                const e = Af()?.$;
                let s = 0;
                if (e) {
                    s = (fd.get(e) || 0) + 1;
                    fd.set(e, s);
                }
                return new ad(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = af(e);
            return e;
        })(n);
        /*#__PURE__*/
        return co($d, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return co(_o, null, null, null, 0, "u7_0");
};

const Bh = /*#__PURE__*/ $a(
/*#__PURE__*/ Ec(zh, "_reC"));

const $d = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ ld((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ co(_o, null, null, null, 0, "u7_0"));
}) : null;

const Qh = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const yd = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Hh = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const Jh = ({track: t, cleanup: n}) => {
    const e = Gf[0], s = Gf[1], o = Gf[2], i = Gf[3];
    const r = t(e.pending);
    const c = Oe;
    i !== null && c && i.reveal.version.value++;
    if (!c || r === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Yh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Uo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return zo(Bo);
    })();
    const s = (t => {
        const n = yf(Xh, null);
        const e = zo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Su(/*#__PURE__*/ Ec(Uh, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = vh(
    /*#__PURE__*/ Ec(Vh, "_reR", [ s ]));
    Su(
    /*#__PURE__*/ Ec(Jh, "_suT", [ e, t, n, s ]));
    const i = !Oe;
    const r = i && dd();
    const c = r ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = Af()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = r ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = r && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && bd(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = r ? /*#__PURE__*/ xc(Qh, [ t, n, o, s ], yd) : null;
    const d = /*#__PURE__*/ xc(Hh, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = r ? /*#__PURE__*/ co(md, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, Br(t, "fallback"), 1, null) : /*#__PURE__*/ co("div", {
        style: xc(Qh, [ t, n, o, s ], yd)
    }, null, Br(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ co("div", null, r ? {
        [ed]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ co(r ? wd : _o, r ? {
        [Ri]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [Ri]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Gh = /*#__PURE__*/ $a(
/*#__PURE__*/ Ec(Yh, "_suC"));

const md = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ ld((t, n, e, s) => {
    const o = n.varProps.boundary;
    const i = n.varProps.delay;
    const r = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !bd(i) ? l.value = "fallback" : o && c && bd(i) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, i));
    s(
    /*#__PURE__*/ co("div", {
        style: r
    }, null, n.children, 1, null));
}) : null;

const wd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ ld(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const i = n.varProps.boundary;
    const r = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return co(_o, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const i = n.children || null;
        const r = s.claimChildrenForSlot(o) || i;
        i && r !== i && t.addUnclaimedProjection(s, "", i);
        /*#__PURE__*/
        return co(_o, n.varProps, n.constProps, r, n.flags, n.key);
    }(t, n, e), e);
    (function f(t, n) {
        t.write(`<template ${ai}="${n}"></template>`);
    })(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, i, r, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        r?.resolve();
        await t.S(async () => {
            t.addRoot(i);
            const e = await o.container.P(s, o);
            (function c(t, n, e, s) {
                t.write(`<template ${ai}="${n}"${s?.attrs ?? ""}>`);
                t.write(e);
                t.write("</template>");
            })(t, n, e.html, r);
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, r, c, i)));
}) : null;

function bd(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

const Kh = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Zh.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return co("script", null, o, null, 0, "prefetch-service-worker");
};

const Zh = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const td = () => null;

globalThis.__qwik && Ye(30, [ globalThis.__qwik, Xs ]);

globalThis.__qwik = Xs;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { fa as $, Oh as Each, vo as Fragment, hf as NoSerializeSymbol, td as PrefetchGraph, Kh as PrefetchServiceWorker, bo as RenderOnce, Fc as Resource, Bh as Reveal, So as SSRComment, Eo as SSRRaw, Ro as SSRStream, ko as SSRStreamBlock, df as SerializerSymbol, Dh as Show, go as SkipRender, _o as Slot, Gh as Suspense, lr as _CONST_PROPS, Pf as _DomContainer, Vs as _EFFECT_BACK_REF, Oi as _ELEMENT_SEQ, dr as _EMPTY_ARRAY, pr as _EMPTY_OBJ, ar as _IMMUTABLE, Ic as _SharedContainer, Yr as _SubscriptionData, Ku as _SubscriptionPatch, Ru as _Task, hr as _UNINITIALIZED, ur as _VAR_PROPS, Yn as _addProjection, Gf as _captures, b as _chk, fe as _createDeserializeContainer, ia as _createQRL, xn as _createStore, Ki as _delay, ue as _deserialize, yc as _dumpState, Ch as _eaC, Nh as _eaT, pn as _executeSsrChores, xc as _fnSignal, Mc as _getAsyncLocalStorage, _r as _getConstProps, Df as _getContextContainer, Ff as _getContextEvent, Lf as _getContextHostElement, Ee as _getDomContainer, ke as _getQContainerElement, w as _getSubscriber, br as _getVarProps, Vu as _hasStoreEffects, Bc as _hmr, Cr as _injectAsyncSignalValue, qe as _invoke, Zr as _isJSXNode, zu as _isStore, Vn as _isStringifiable, Pu as _isTask, Xf as _jsxBranch, ao as _jsxC, po as _jsxQ, ho as _jsxS, co as _jsxSorted, fo as _jsxSplit, Xe as _mapApp_findIndx, Ve as _mapArray_get, We as _mapArray_set, ju as _markSignalAsExternallyOwned, xe as _newInvokeContext, Sc as _noopQrl, kc as _noopQrlDEV, Dn as _preprocessState, pa as _qrlSync, On as _qrlToString, Rc as _qrlWithChunk, Pc as _qrlWithChunkDEV, zh as _reC, Vh as _reR, Uh as _reT, Ac as _regSymbol, Zn as _removeProjection, _ as _res, mf as _resolveContextWithoutSequentialScope, Mo as _restProps, n as _retryOnPromise, jc as _rsc, I as _run, le as _serialize, Qn as _setEvent, Gn as _setProjectionTarget, Fh as _shC, Lh as _shT, Yh as _suC, Jh as _suT, An as _task, Kn as _updateProjectionProps, Jn as _useHmr, v as _val, of as _verifySerializable, kl as _vnode_ensureElementInflated, pu as _vnode_getAttrKeys, Ql as _vnode_getElementName, Yl as _vnode_getFirstChild, _l as _vnode_getProp, xl as _vnode_getVNodeForChildNode, Wl as _vnode_insertBefore, $l as _vnode_isElementVNode, ml as _vnode_isMaterialized, wl as _vnode_isTextVNode, vl as _vnode_isVirtualVNode, dl as _vnode_newVirtual, zl as _vnode_remove, gl as _vnode_setProp, En as _vnode_toString, Wf as _waitUntilRendered, zn as _walkJSX, Br as _wrapProp, Hr as _wrapSignal, wa as component$, $a as componentQrl, Xr as createAsync$, jr as createAsyncQrl, Dr as createComputed$, Or as createComputedQrl, pf as createContextId, g as createElement, Wr as createSerializer$, Lr as createSerializerQrl, Fr as createSignal, va as event$, ha as eventQrl, Wu as forceStoreEffects, ba as getClientManifest, Ee as getDomContainer, Pe as getLocale, ms as getPlatform, g as h, xr as implicit$FirstArg, Ec as inlinedQrl, qc as inlinedQrlDEV, je as isDev, qu as isSignal, yo as jsx, mo as jsxDEV, wo as jsxs, af as noSerialize, gc as qrl, Tc as qrlDEV, _a as render, ys as setPlatform, da as sync$, Nf as untrack, Uu as unwrapStore, xh as useAsync$, Mh as useAsyncQrl, bh as useComputed$, vh as useComputedQrl, zo as useConstant, yf as useContext, $f as useContextProvider, Ih as useErrorBoundary, Ea as useId, Oc as useLexicalScope, Xc as useOn, Wc as useOnDocument, Vc as useOnWindow, Ph as useResource$, Lc as useResourceQrl, Eh as useSerializer$, gh as useSerializerQrl, Ie as useServerData, Uo as useSignal, ga as useStore, ph as useStyles$, dh as useStylesQrl, yh as useStylesScoped$, $h as useStylesScopedQrl, Th as useTask$, Su as useTaskQrl, qh as useVisibleTask$, Sh as useVisibleTaskQrl, Xs as version, Te as withLocale };
